export const tc = {
  ACCEPT: '接受',
  ACCOUNT: '帳戶',
  ACCOUNT_SETTINGS: '帳戶設定',
  APP_SETTINGS: '設定',
  ADD_CONTENT: '新增內容',
  ADD_MIND_MAP_FILL_IN_BOX: '新增填充方塊',
  ADD_MIND_MAP_LABLE_BOX: '新增描述方塊',
  ADMIN_TASK: '管理員職務',
  AI_MODEL: 'AI 模型',
  AI_SUGGEST: '生成AI內容建議',
  FINISHED: '完成',
  ERROR: '錯誤',
  AI_MODEL_WAIT_TIME: 'AI模型需花1至2分鐘生成內容建議',
  AI_GENERATED_RESPONSES: 'AI生成的建議活動內容',
  SELECT_RESPONSES: '選擇AI回應',
  AI_MODEL_USED: '模型：{0}',
  AI_RESPONSE_NUMBER: '回應 {0}',
  AI_REVIEW_SUGGESTIONS_TITLE: 'AI 內容建議',
  AI_REVIEW_INTRO: '檢視並編輯以下建議，然後新增你想要的項目。',
  AI_SUGGESTION_INCLUDE: '新增此建議',
  AI_SUGGESTION_CONTENT: '內容',
  AI_FILL_ANSWER: '答案 {0}',
  AI_TABLE_COLUMNS: '欄標題（以逗號分隔）',
  AI_TABLE_ROWS: '列標題（以逗號分隔）',
  AI_ADD_SELECTED: '新增已選項目',
  AI_NO_SUGGESTION_SELECTED: '請至少選擇一項建議以新增。',
  AI_NO_SUGGESTIONS: 'AI 沒有提供可用的建議，請再試一次。',
  AI_PARSE_ERROR: '無法讀取 AI 的回應，請再試一次。',
  AI_SUGGESTIONS_ADDED: '已新增 {0} 項內容。',
  AI_SUGGEST_BUTTON: 'AI 建議',
  AI_SUGGEST_RENAME_TITLE: '更新熱點名稱',
  AI_SUGGEST_RENAME_REMINDER: '此熱點仍使用預設名稱「{0}」。AI 建議會根據熱點名稱生成內容，請先將名稱更新為實際的熱點名稱，以取得更貼切的建議。',
  CONTINUE_ANYWAY: '仍然繼續',
  AI_START_GENERATION: '開始AI 建議',
  AI_GENERATING: 'AI 正在生成內容建議，請稍候（約需 1 至 2 分鐘）…',
  AI_CHANGE_OPTIONS: '更改選項',
  AI_SETUP_INTRO: '選擇生成選項，然後開始生成 AI 內容建議。',
  AI_GENERATE_FAILED: 'AI 生成失敗，請再試一次。',
  AI_CONTENT_TYPES_TO_GENERATE: '建議內容類型',
  AI_CONTENT_TYPES_PLACEHOLDER: '不選擇即代表全部類型',
  AI_CURRICULUM_KLA: '學習領域',
  AI_CURRICULUM_SUBJECT: '科目',
  AI_CURRICULUM_LEVEL: '學生級別',
  AI_CURRICULUM_NONE: '不指定',
  AI_CURRICULUM_CROSS_LEVEL: '跨級別',
  AI_CURRICULUM_HINT: '選擇課程範圍後，AI 會依據香港教育局課程文件出題（可不選）。',
  AI_OUTPUT_LANGUAGE: '輸出語言',
  AI_OUTPUT_LANGUAGE_AUTO: '自動（跟隨課程）',
  AI_EXCEED_MAX_COMPONENT: '無法新增：現有 {0} 項內容，上限為 {1} 項，最多只可再新增 {2} 項。請減少選取的建議。',
  AI_SUGGESTED_QUESTIONS: 'AI 建議題目',
  ALL_SCHOOLS: '所有學校',
  ALL_USERS: '所有用戶',
  ARCHIVE: '匯出到Excel',
  EXPORT_ALL_STUDENT_ANSWERS: '匯出全部學生答案到Excel',
  EXPORT_ALL_AI_SCORES: '匯出全部學生 AI 評分',
  EXPORT_ALL_MARKS: '匯出全部學生分數',
  NO_SCORE_TO_EXPORT: '尚未有可匯出的學生分數',
  ANSWER: '答案',
  ANSWER_NOT_ALL_FILLED: '請為答案提供最少4個圖片檔案',
  AUTHOR: '作者',
  BACK: '上一步',
  BACK_TO_LOCALE_LIST: '返回考察教件列表',
  CANCEL: '取消',
  DO_NOT_SHOW_AGAIN: '不再顯示',
  CATEGORY: '類別',
  CATEGORY_CREATION: '創作',
  CATEGORY_EXPERIENCE: '體驗',
  CATEGORY_EXPERIMENT: '實驗',
  CATEGORY_EXPLORATION: '探究',
  CATEGORY_NONE: '沒分類',
  CATEGORY_KNOWLEDGE: '知識',
  CHANGE: '更改',
  CHANGE_PASSWORD: '更改密碼',
  CHOICE: '選擇',
  CLEAR: '清除',
  CLOSE: '關閉',
  COLOR: '顏色',
  COLUMN: '欄',
  COMPARE_ANSWERS: '顯示所有學生答案',
  CONTENT: '內容',
  CONTENT_NAME: '標題',
  CONTENT_PHOTO_FILE_INSTRUCTION: '如需描述多於1張圖片，可創建多個圖文描述。\n 圖片不是必須的，但建議使用，以增加學習動機。 \n 每個圖文描述上限為2000字。',
  CONTENT_TYPE: '內容種類',
  CREATE_CONTENT: '新增內容',
  CONTENT_TYPE_GROUP_PRESENTATION: '展示內容',
  CONTENT_TYPE_GROUP_PRESENTATION_DESCRIPTION: '用於展示資訊或媒體內容',
  CONTENT_TYPE_GROUP_RESPONSE: '學生作答活動',
  CONTENT_TYPE_GROUP_RESPONSE_DESCRIPTION: '用於學生回答、提交或完成任務',
  CONTINUE_EDITING: '繼續編輯',
  CORRECT: '正確',
  CORRECT_ANSWER: '正確答案',
  CORRECT_ANSWER_CONTECT_NOT_FILLED: '請填寫正確答案',
  CORRECT_ANSWER_NOT_SELECTED: '請選擇最少一個正確答案',
  COVER_IMAGE: '封面圖片',
  CREATE: '建立',
  CREATE_SCHOOL: '建立學校',
  CREATE_USER: '建立用戶',
  PLATFORM_ADMIN_ROLE: 'CLST 管理員',
  PLATFORM_ADMIN_CREATE_WARNING: '警告：此帳戶可管理所有學校的資料。只應為獲授權的 CLST 平台管理人員建立此帳戶。',
  CREATED: '已建立',
  DARK_MODE: '深色模式',
  DECLINE: '拒絕',
  DELETE: '刪除',
  DELETE_CONTENT: '刪除內容',
  DELETE_FAILED: '刪除失敗',
  DELETE_FILE: '刪除檔案',
  DELETE_HOTSPOT: '刪除熱點',
  DELETE_LOCALE: '刪除考察教件',
  DELETE_MIND_MAP_BOX: '刪除方塊',
  DELETE_MIND_MAP_LINK: '移除連結',
  DELETE_REMINDER: '刪除後將不能復原，請確定是否刪除所選項目？',
  DELETED: '所選項目已被刪除',
  DESCRIPTION: '描述',
  DESCRIPTION_AUDIO: '聲音描述',
  DESCRIPTION_FILL_IN_THE_BLANK_AFTER: '填充部分後的文字',
  DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: '填充部分前的文字',
  DESCRIPTION_IMAGE: '描述圖片',
  DESCRIPTION_NOT_FILLED: '請填寫描述',
  DESCRIPTION_QUESTION: '問題',
  DESCRIPTION_TAKE_PHOTO: '拍攝題描述',
  DESCRIPTION_TAKE_RECORD: '錄音指示',
  DESCRIPTION_DRAWING_TASK: '繪圖題的問題/描述',
  DESCRIPTION_TEXT: '描述',
  DESCRIPTION_VIDEO: '影片描述',
  DETAILS: '基本資料',
  DIFFICULTY: '難度',
  DISCARD: '放棄',
  DISCARD_CHANGES: '放棄更改',
  DISPLAY_NAME: '顯示名稱',
  DISPLAY_NAME_FOR_LOCALE: '考察教件創作者名稱',
  DISPLAY_NAME_BLANK_REMINDER: '顯示名稱不能空白',
  DONE: '完成',
  DONE_EDITING: '完成編輯',
  DOWNLOAD: '下載',
  EDIT: '編輯',
  EDIT_PROFILE: '編輯個人資料',
  EDIT_SCORE: '編輯分數',
  EDIT_CONTENT: '編輯內容',
  EDIT_HOTSPOTS: '編輯熱點',
  EDIT_USER: '編輯用戶',
  EDIT_LOCALE: '編輯考察教件',
  SUBSCRIPTION_DETAILS: '訂閱詳情',
  SUBSCRIPTION_TAB: '訂閱計劃',
  SUBSCRIPTION_KEYWORD_SEARCH: '關鍵字搜尋',
  SUBSCRIPTION_KEYWORD_HINT: '名稱 / 備註',
  SUBSCRIPTION_SORT_CREATED: '建立時間',
  SUBSCRIPTION_SORT_NAME_ZH: '中文名稱',
  SUBSCRIPTION_SORT_NAME_EN: '英文名稱',
  SUBSCRIPTION_SORT_DESC: 'DESC',
  SUBSCRIPTION_SORT_ASC: 'ASC',
  SUBSCRIPTION_SEARCHING: '搜尋中...',
  SUBSCRIPTION_NO_RESULT: '沒有找到訂閱計劃',
  SUBSCRIPTION_FOUND_COUNT: '找到 {0} 個訂閱計劃',
  SUBSCRIPTION_LOCALE_BUTTON: '設定額外LOCALE',
  SUBSCRIPTION_EXTRA_LOCALE_USAGE: '已指派額外 LOCALE 數量 / 上限',
  SUBSCRIPTION_PRIVILEGE_BUTTON: '權限',
  SUBSCRIPTION_LOCALE_FAILED: '無法取得訂閱的 LOCALE 清單',
  SUBSCRIPTION_PRIVILEGE_FAILED: '無法取得訂閱的權限',
  SUBSCRIPTION_SEARCH_FAILED: '訂閱計劃搜尋失敗',
  SUBSCRIPTION_NAME_ZH: '名稱 (中)',
  SUBSCRIPTION_NAME_EN: '名稱 (英)',
  SUBSCRIPTION_IS_TEMPLATE: '是否範本',
  SUBSCRIPTION_DOUBLE_CLICK_EDIT: '雙擊以編輯',
  SUBSCRIPTION_UPDATE_SUCCESS: '訂閱計劃已更新',
  SUBSCRIPTION_UPDATE_FAILED: '更新訂閱計劃失敗',
  SUBSCRIPTION_LOCALE_TITLE: '在訂閱中的 額外 LOCALE 設定',
  SUBSCRIPTION_ASSIGNED_LOCALES: '已指派 LOCALE',
  SUBSCRIPTION_AVAILABLE_LOCALES: '可指派 LOCALE',
  SUBSCRIPTION_LOCALE_SEARCH_BY_USER: '用戶',
  SUBSCRIPTION_LOCALE_SEARCH_BY_SUBSCRIPTION: '其他訂閱',
  SUBSCRIPTION_LOCALE_SEARCH_BY_KEYWORD: '關鍵字',
  SUBSCRIPTION_LOCALE_USER_SEARCH_PLACEHOLDER: '搜尋用戶名稱或顯示名稱',
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_SEARCH_PLACEHOLDER: '搜尋訂閱中文或英文名稱',
  SUBSCRIPTION_LOCALE_SEARCH_PLACEHOLDER: '搜尋 LOCALE 名稱',
  SUBSCRIPTION_LOCALE_USER_SEARCH_PROMPT: '以用戶名稱或顯示名稱搜尋',
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_SEARCH_PROMPT: '以其他訂閱的中文或英文名稱搜尋',
  SUBSCRIPTION_LOCALE_NO_USER_RESULT: '找不到相符的用戶',
  SUBSCRIPTION_LOCALE_NO_SUBSCRIPTION_RESULT: '找不到相符的訂閱',
  SUBSCRIPTION_LOCALE_USER_FILTER: '用戶：{0}',
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_FILTER: '訂閱：{0}',
  SUBSCRIPTION_LOCALE_SOURCE_SEARCH_FAILED: '搜尋用戶或訂閱失敗',
  SUBSCRIPTION_LOCALE_SEARCH_PROMPT: '搜尋要指派的 LOCALE',
  SUBSCRIPTION_LOCALE_NO_SEARCH_RESULT: '找不到可指派的 LOCALE',
  SUBSCRIPTION_LOCALE_ASSIGN_SELECTED: '指派已選取的 LOCALE',
  SUBSCRIPTION_LOCALE_LIMIT_REACHED: '已達 LOCALE 數量上限',
  SUBSCRIPTION_LOCALE_SEARCH_FAILED: '搜尋 LOCALE 失敗',
  SUBSCRIPTION_NO_LOCALE: '沒有 LOCALE',
  SUBSCRIPTION_PRIVILEGE_TITLE: '訂閱權限',
  SUBSCRIPTION_PRIVILEGE_NAME: '權限名稱',
  SUBSCRIPTION_NO_PRIVILEGE: '沒有權限',
  PLAN_EXTRA_LOCALE_VALUE: '額外 {0} 個 LOCALE',
  PLAN_EXTRA_LOCALE_ADMIN_HELP: '此訂閱計劃可額外指派的 LOCALE 數量上限。',
  // Extra Locale (預製教材範本) selection — teacher-facing dialog
  EXTRA_LOCALE_MENU: '管理預製教材',
  EXTRA_LOCALE_TAB: '預製教材範本',
  EXTRA_LOCALE_TAB_HELP: '貴校已選取的預製教材範本，只供檢視，不可編輯或刪除。',
  EXTRA_LOCALE_TITLE: 'EduVenture-AI®️預製教材範本選單',
  EXTRA_LOCALE_HEADER_INTRO: '訂閱「{0}」方案的學校，請選取 {1} 個預製教材範本。',
  EXTRA_LOCALE_HEADER_INTRO_NO_PLAN: '請選取 {0} 個預製教材範本。',
  EXTRA_LOCALE_NOTES_TITLE: '備註：',
  EXTRA_LOCALE_NOTE_PARTIAL: '如現階段未能一次過選定全部範本，可先選取心儀範本，其餘可於服務生效期內選取。',
  EXTRA_LOCALE_NOTE_MANUAL: '選取範本後，教師可點選主頁上方的「預製教材範本」，再點選所需 LOCALE 卡片底部的「PDF」圖示，以下載相應的教師參考手冊。',
  EXTRA_LOCALE_NOTE_RESOURCES: '科目上架時間表及範本詳情，請瀏覽 ',
  EXTRA_LOCALE_NOTE_RESOURCES_SUFFIX: '。',
  EXTRA_LOCALE_RESOURCES_URL: 'https://clst.fed.cuhk.edu.hk/evqef/resources/',
  EXTRA_LOCALE_CONTACT_TITLE: '如對上述安排有任何疑問，歡迎與本中心同事聯絡：',
  // Staff roster for the notes block. Numbered rather than named after the
  // colleagues so the keys survive a change of duty.
  EXTRA_LOCALE_CONTACT_1: '彭小姐：3943 0425（一般查詢）',
  EXTRA_LOCALE_CONTACT_3: '楊先生：3943 0659（EduVenture-AI®️ 操作疑難排解）',
  EXTRA_LOCALE_QUOTA_SUMMARY: '已選 {0} 個／上限 {1} 個',
  EXTRA_LOCALE_REMAINING: '尚餘 {0} 個名額',
  EXTRA_LOCALE_PERMANENT_WARNING: '範本一經選定，不設更換，敬請貴校各科老師按學生學習需要共同商議、慎重選擇。',
  EXTRA_LOCALE_NOT_ELIGIBLE: '貴校的訂閱計劃不包括預製教材範本。如有查詢，請聯絡 EduVenture 團隊。',
  EXTRA_LOCALE_SELECTION_TITLE: '選擇預製教材範本',
  EXTRA_LOCALE_SELECTED_LIST: '已加入的 LOCALE',
  EXTRA_LOCALE_NONE_SELECTED: '尚未選擇任何範本。',
  EXTRA_LOCALE_AVAILABLE_LIST: '可選的 LOCALE',
  EXTRA_LOCALE_CATALOG_EMPTY: '暫時沒有可選擇的範本。',
  EXTRA_LOCALE_SELECTED_BY: '選擇人',
  EXTRA_LOCALE_SELECTED_AT: '選擇日期',
  EXTRA_LOCALE_ALREADY_SELECTED_ROW: '已選擇',
  EXTRA_LOCALE_PENDING_ROW: '準備提交',
  EXTRA_LOCALE_ADD: '加入',
  EXTRA_LOCALE_SELECTED_TO_ADD: '已選 {0} 個',
  EXTRA_LOCALE_REMOVE_PENDING: '從已加入項目移除',
  EXTRA_LOCALE_SUBMIT: '提交選擇',
  EXTRA_LOCALE_CONFIRM_TITLE: '確認範本選擇',
  EXTRA_LOCALE_CONFIRM_INTRO: '你將選擇以下 {0} 個範本，提交後不可更改或刪除：',
  EXTRA_LOCALE_CONFIRM_SUBMIT: '確認提交（不可更改）',
  EXTRA_LOCALE_SUBMIT_SUCCESS: '已提交範本選擇。',
  EXTRA_LOCALE_SUBMIT_FAILED: '提交範本選擇失敗',
  EXTRA_LOCALE_QUOTA_EXCEEDED: '選擇數量超出訂閱計劃上限（已用 {0}／上限 {1}）。',
  EXTRA_LOCALE_NOTHING_TO_ADD: '所選範本已全部選擇過。',
  EXTRA_LOCALE_LOAD_FAILED: '載入預製教材範本失敗',
  // Extra Locale — admin management (platform admins, role >= 3)
  EXTRA_LOCALE_ADMIN_SECTION: '預製教材範本',
  EXTRA_LOCALE_ADMIN_TAB: '範本管理',
  EXTRA_LOCALE_ADMIN_HISTORY: '選擇紀錄',
  EXTRA_LOCALE_ADMIN_HINT: '此列表是所有學校可選的預製教材範本。關閉「開放選擇」後，學校將不會在選單中看到該範本；已有的選擇紀錄不受影響。',
  EXTRA_LOCALE_ADMIN_CREATE: '新增範本',
  EXTRA_LOCALE_ADMIN_EDIT: '編輯範本',
  EXTRA_LOCALE_ADMIN_DELETE: '刪除範本',
  EXTRA_LOCALE_ADMIN_DELETE_CONFIRM: '確定刪除範本「{0}」？學校已有的選擇紀錄會保留。',
  EXTRA_LOCALE_ADMIN_DELETE_SELECTED_WARNING: '此範本已被選擇 {0} 次。',
  EXTRA_LOCALE_ADMIN_EMPTY: '尚未新增任何範本',
  EXTRA_LOCALE_NAME: '名稱',
  EXTRA_LOCALE_CATEGORY: '類別',
  EXTRA_LOCALE_CATEGORY_HINT: '例：小學 - 常識科（人文科及科學科）',
  EXTRA_LOCALE_REMARKS: '備註',
  EXTRA_LOCALE_EPACK_ID: 'LOCALE 編號',
  EXTRA_LOCALE_EPACK_NAME: 'LOCALE 名稱',
  EXTRA_LOCALE_EPACK_PICKER: 'LOCALE',
  EXTRA_LOCALE_EPACK_PICKER_HINT: '輸入 LOCALE 名稱關鍵字，然後從清單中選擇',
  EXTRA_LOCALE_EPACK_PICKER_PLACEHOLDER: '搜尋 LOCALE 名稱...',
  EXTRA_LOCALE_EPACK_SELECTED: '已選擇',
  EXTRA_LOCALE_EPACK_NO_RESULTS: '沒有符合的 LOCALE',
  EXTRA_LOCALE_EPACK_REQUIRED: '請從清單選擇 LOCALE',
  EXTRA_LOCALE_EXPORT_CSV: '匯出 CSV',
  EXTRA_LOCALE_EXPORT_FAILED: '匯出失敗',
  EXTRA_LOCALE_EXPORT_FROM: '匯出開始日期',
  EXTRA_LOCALE_EXPORT_TO: '匯出結束日期',
  EXTRA_LOCALE_EXPORT_RANGE_INVERTED: '結束日期不可早於開始日期。',
  EXTRA_LOCALE_EXPORT_RANGE_INVALID: '日期格式不正確，請使用日曆選擇日期。',
  EXTRA_LOCALE_EXPORT_EMPTY: '所選日期範圍內沒有選擇紀錄。',
  EXTRA_LOCALE_EXPORT_TRUNCATED: '伺服器最多回傳 {0} 筆紀錄，此日期範圍可能未完整匯出；請縮短範圍或加上關鍵字。',
  EXTRA_LOCALE_EPACK_DANGLING: 'LOCALE 已刪除',
  EXTRA_LOCALE_CATEGORY_INDEX: '類別排序',
  EXTRA_LOCALE_CATEGORY_INDEX_HINT: '類別在選單中的次序；同一類別的範本請使用相同數值',
  EXTRA_LOCALE_DISPLAY_INDEX_HINT: '範本在類別內的顯示次序',
  EXTRA_LOCALE_DISPLAY_INDEX: '排序',
  EXTRA_LOCALE_ENABLED: '開放選擇',
  EXTRA_LOCALE_SELECTION_COUNT: '已選次數',
  EXTRA_LOCALE_SCHOOL: '學校',
  EXTRA_LOCALE_USER: '用戶',
  EXTRA_LOCALE_HISTORY_EMPTY: '沒有選擇紀錄',
  EXTRA_LOCALE_SEARCH_PLACEHOLDER: '搜尋範本、學校或用戶...',
  EXTRA_LOCALE_SAVE_FAILED: '儲存範本失敗',
  EXTRA_LOCALE_DELETE_FAILED: '刪除範本失敗',

  // 教師參考手冊 — 每個預製教材範本的教師參考手冊 (PDF)。管理員於「管理範本」
  // 上載；學校「選擇範本後」可於「Extra LOCALE」分頁下載。此下載途徑即
  // EXTRA_LOCALE_NOTE_MANUAL 向學校交代的取用方法，若分頁或圖示改動，兩者須一併更新。
  EXTRA_LOCALE_MANUAL: '教師參考手冊 (PDF)',
  EXTRA_LOCALE_MANUAL_COLUMN: '教師參考手冊',
  EXTRA_LOCALE_MANUAL_DOWNLOAD: '下載教師參考手冊',
  EXTRA_LOCALE_MANUAL_DOWNLOAD_FAILED: '無法下載教師參考手冊',
  // 瀏覽器儲存檔案時接在 LOCALE 名稱之後，令下載檔名為
  // 「GS08 [TC] (26 27) 山頂 教師參考手冊.pdf」，而非 blob 的隨機檔名。
  EXTRA_LOCALE_MANUAL_FILE_SUFFIX: '教師參考手冊',
  EXTRA_LOCALE_MANUAL_UPLOAD: '上載教師參考手冊',
  EXTRA_LOCALE_MANUAL_REPLACE: '更換教師參考手冊',
  EXTRA_LOCALE_MANUAL_DELETE: '刪除教師參考手冊',
  // 說明真正的後果：範本仍在，但下載會消失。
  EXTRA_LOCALE_MANUAL_DELETE_CONFIRM: '確定刪除「{0}」的教師參考手冊？範本本身不受影響。',
  EXTRA_LOCALE_MANUAL_DELETE_SELECTED_WARNING: '已選擇此範本的 {0} 間學校將無法再下載此 PDF。',
  EXTRA_LOCALE_MANUAL_UPLOADED: '教師參考手冊已上載',
  EXTRA_LOCALE_MANUAL_DELETED: '教師參考手冊已刪除',
  EXTRA_LOCALE_MANUAL_UPLOAD_FAILED: '上載教師參考手冊失敗',
  EXTRA_LOCALE_MANUAL_DELETE_FAILED: '刪除教師參考手冊失敗',
  EXTRA_LOCALE_MANUAL_NOT_PDF: '教師參考手冊必須是 PDF 檔案。',
  EXTRA_LOCALE_MANUAL_TOO_LARGE: '檔案過大（上限 {0}MB）。',
  EXTRA_LOCALE_MANUAL_ADMIN_HELP: 'PDF 格式，檔案上限 20MB。已選擇此範本的學校可於「Extra LOCALE」分頁下載，學生裝置不會下載此檔案。',

  // 選擇紀錄定時電郵（預製教材範本 > 通知電郵設定）。以下時間描述的是 ACA
  // 排程工作，並非此頁面可更改的設定：每日香港時間上午 9:00 寄出前一日，
  // 星期一另加寄上一週。若排程有變，須與 selection_report_service 一併更新。
  EXTRA_LOCALE_REPORT_TAB: '通知電郵設定',
  EXTRA_LOCALE_REPORT_SCHEDULE_HINT: '系統會於每日香港時間上午 9:00 自動將「前一日」的選擇紀錄以電郵寄出；逢星期一上午 9:00 另外加寄「上一週（星期一至星期日）」的選擇紀錄。每封電郵附有與「選擇紀錄」頁面相同的 CSV 檔。',
  EXTRA_LOCALE_REPORT_SMTP_MISSING: '伺服器尚未設定 SMTP 帳戶，即使填寫收件地址亦不會發出電郵。請聯絡系統管理員。',
  EXTRA_LOCALE_REPORT_RECIPIENTS: '收件電郵地址',
  EXTRA_LOCALE_REPORT_RECIPIENTS_HELP: '每行一個地址，亦可用逗號或分號分隔。留空即停止發送。',
  EXTRA_LOCALE_REPORT_RECIPIENT_COUNT: '目前已儲存 {0} 個收件地址',
  EXTRA_LOCALE_REPORT_DAILY: '每日發送（前一日的選擇紀錄）',
  EXTRA_LOCALE_REPORT_WEEKLY: '每星期一發送（上一週的選擇紀錄）',
  EXTRA_LOCALE_REPORT_SEND_WHEN_EMPTY: '沒有紀錄時仍然發送',
  EXTRA_LOCALE_REPORT_SEND_WHEN_EMPTY_HELP: '關閉後，該期間若沒有任何選擇紀錄便不會發出電郵——收不到郵件時將無法分辨是「沒有紀錄」還是「發送失敗」。',
  EXTRA_LOCALE_REPORT_SEND_DAILY_NOW: '立即發送每日報告',
  EXTRA_LOCALE_REPORT_SEND_WEEKLY_NOW: '立即發送每週報告',
  EXTRA_LOCALE_REPORT_SEND_NOW_HELP: '「立即發送」會依照上述已儲存的收件名單，寄出與排程相同的日期範圍，用作測試。',
  EXTRA_LOCALE_REPORT_SAVE_FIRST: '請先儲存設定，再發送測試郵件。',
  EXTRA_LOCALE_REPORT_SENT: '已發送 {0} 至 {1}（{2} 筆紀錄）',
  EXTRA_LOCALE_REPORT_NO_RECIPIENTS: '尚未設定收件電郵地址。',
  EXTRA_LOCALE_REPORT_SAVED: '已儲存通知電郵設定',
  EXTRA_LOCALE_REPORT_LOAD_FAILED: '無法載入通知電郵設定',
  EXTRA_LOCALE_REPORT_SAVE_FAILED: '儲存通知電郵設定失敗',
  EXTRA_LOCALE_REPORT_SEND_FAILED: '發送失敗',
  VALUE: '值',
  GROUP: '群組',
  LANG: '語言',
  SUBSCRIPTION_CREATE: '新增訂閱計劃',
  SUBSCRIPTION_NAME_REQUIRED: '中文名稱必填',
  SUBSCRIPTION_NAME_EN_REQUIRED: '英文名稱必填',
  SUBSCRIPTION_CREATE_SUCCESS: '已新增訂閱計劃',
  SUBSCRIPTION_CREATE_FAILED: '新增訂閱計劃失敗',
  SUBSCRIPTION_DELETE: '刪除訂閱計劃',
  SUBSCRIPTION_DELETE_CONFIRM: '確定要刪除此訂閱計劃嗎？',
  SUBSCRIPTION_DELETE_SUCCESS: '訂閱計劃已刪除',
  SUBSCRIPTION_DELETE_FAILED: '刪除訂閱計劃失敗',
  SUBSCRIPTION_DELETE_BLOCKED: '此訂閱計劃已指派給學校，請先刪除相關學校訂閱。',
  SUBSCRIPTION_ASSIGNED_SCHOOLS: '已指派的學校',
  SUBSCRIPTION_COPY_PRIV_LABEL: '複製權限來源訂閱',
  SUBSCRIPTION_COPY_LOCALE_LABEL: '同時複製來源訂閱的額外 LOCALE',
  SUBSCRIPTION_SOURCE_LABEL: '來源',
  SUBSCRIPTION_SOURCE_NOT_SELECTED: '未選擇',
  SUBSCRIPTION_SOURCE_PRIVILEGES: '來源訂閱權限',
  SUBSCRIPTION_SELECT_FROM_TEMPLATES: '從範本選擇',
  SUBSCRIPTION_NO_TEMPLATES: '沒有可用的訂閱範本',
  SUBSCRIPTION_PICKER_PLACEHOLDER: '搜尋訂閱名稱...',
  SUBSCRIPTION_EPICKER_PLACEHOLDER: '搜尋教件名稱',
  SUBSCRIPTION_ADD_EPICK: '加入教件',
  SUBSCRIPTION_REMOVE_CONFIRM: '確定要移除嗎？',
  SUBSCRIPTION_REMOVE_SELECTED: '刪除已選項目',
  SUBSCRIPTION_REMOVE_SELECTED_CONFIRM: '確定要刪除已選取的 {0} 個 LOCALE 嗎？',
  SUBSCRIPTION_REMOVE_SELECTED_FAILED: '有 {0} 個 LOCALE 刪除失敗',
  DELETE: '刪除',
  RESET: '重設',
  SCHOOL_SUBSCRIPTION_FILTER: '按訂閱篩選學校',
  SCHOOL_ELAFP_FILTER_TOOLTIP: '只顯示持有 eLAFP 訂閱的學校',
  SCHOOL_MATCHED_SUBSCRIPTION: '符合的訂閱',
  SCHOOL_LAST_SUBSCRIPTION_UPDATE: '最近訂閱更新',
  SCHOOL_EPACK_QUOTA: 'ePack 配額',
  SCHOOL_EPACK_QUOTA_NOT_ASSIGNED: '尚未分配',
  SCHOOL_SUBSCRIPTION_KEYWORD_NO_MATCH: '沒有訂閱符合「{0}」',
  SCHOOL_SUBSCRIPTION_KEYWORD_PARTIAL: '{1} 個訂閱中有 {0} 個載入失敗，列表可能不完整',
  SCHOOL_SUBSCRIPTION_KEYWORD_TRUNCATED: '只顯示 {1} 間學校中的前 {0} 間，請調高結果數量上限',
  SCHOOL_SUBSCRIPTION_KEYWORD_CAPPED: '訂閱查詢已達 {0} 個上限，較新的訂閱可能未列入',
  SCHOOL_INCLUDE_EXPIRED_LABEL: '包括已過期',
  SCHOOL_INCLUDE_EXPIRED_TOOLTIP: '連同已過期的訂閱一併顯示；預設只顯示未過期的訂閱',
  SCHOOL_RESULT_COUNT: '共 {0} 間學校',
  SCHOOL_RESULT_COUNT_TRUNCATED: '顯示 {0} 間，共 {1} 間學校',
  SCHOOL_RESULT_COUNT_CAPPED: '顯示前 {0} 間學校，可能未完',
  SCHOOL_EXPORT_CSV: '匯出 CSV',
  SCHOOL_EXPORT_CSV_TOOLTIP: '將目前篩選出的所有學校匯出為 CSV',
  SCHOOL_EXPORT_DONE: '已匯出 {0} 間學校',
  SCHOOL_EXPORT_EMPTY: '沒有可匯出的學校',
  SCHOOL_EXPORT_SEARCHING: '搜尋尚未完成，請稍候再匯出',
  SCHOOL_EXPORT_CAPPED: '匯出上限為 {0} 間學校，可能未完 — 請收窄篩選條件',
  SCHOOL_EXPORT_FAILED: '匯出失敗',
  SCHOOL_SUBSCRIPTION_ACTION: '訂閱',
  SCHOOL_SUBSCRIPTION_DIALOG_TITLE: '學校訂閱',
  SCHOOL_SUBSCRIPTION_ADD: '為學校加入訂閱',
  SCHOOL_SUBSCRIPTION_CREATE: '創建訂閱',
  SCHOOL_SUBSCRIPTION_SEARCH_PLACEHOLDER: '搜尋訂閱...',
  SCHOOL_SUBSCRIPTION_NONE: '暫無訂閱',
  SCHOOL_SUBSCRIPTION_SELECT: '請先選擇訂閱',
  SCHOOL_SUBSCRIPTION_ADDED: '已加入訂閱',
  SCHOOL_SUBSCRIPTION_LOAD_FAILED: '載入訂閱失敗',
  SCHOOL_SUBSCRIPTION_START: '開始日',
  SCHOOL_SUBSCRIPTION_START_REQUIRED: '請選擇開始日',
  SCHOOL_SUBSCRIPTION_DURATION: '期限',
  SCHOOL_SUBSCRIPTION_HALF_YEAR: '半年',
  SCHOOL_SUBSCRIPTION_ONE_YEAR: '1 年',
  SCHOOL_SUBSCRIPTION_TWO_YEARS: '2 年',
  SCHOOL_SUBSCRIPTION_THREE_YEARS: '3 年',
  SCHOOL_SUBSCRIPTION_EXPIRE: '到期日',
  SCHOOL_SUBSCRIPTION_STATUS: '狀態',
  SCHOOL_SUBSCRIPTION_ACTIVE: '有效',
  SCHOOL_SUBSCRIPTION_EXPIRED: '已到期',
  SCHOOL_SUBSCRIPTION_UPDATE: '編輯',
  SCHOOL_SUBSCRIPTION_UPDATED: '訂閱記錄已更新',
  SCHOOL_SUBSCRIPTION_UPDATE_FAILED: '更新訂閱記錄失敗',
  SCHOOL_SUBSCRIPTION_DELETE: '移除訂閱',
  SCHOOL_SUBSCRIPTION_DELETED: '訂閱已移除',
  SCHOOL_SUBSCRIPTION_DELETE_FAILED: '移除訂閱失敗',
  SCHOOL_SUBSCRIPTION_DELETE_CONFIRM: '確定要從學校移除此訂閱嗎？',
  PLAN: '計劃',
  SUBSCRIPTION_PERIOD: '訂閱期間',
  CLOSE: '關閉',
  EMAIL: '電郵',
  EMAIL_INCORRECT_REMINDER: '電郵格式不正確',
  EMPTY_CONTENT_PROMPT: '確定不填寫內容嗎？',
  EMPTY_CONTENT_REMINDER: '這熱點未有內容，請按「＋」來創建',
  EMPTY_HOTSPOT_PROMPT: '確定不增加熱點嗎？',
  EMPTY_HOTSPOT_REMINDER: '這考察教件未有熱點，請按「新的熱點」來創建',
  EMPTY_SUBMISSION_REMINDER: '這考察教件未有人提交答案。請要求學生於應用程式裏遞交答案，然後在此檢閱',
  EMPTY_TAG_PROMPT: '確定不增加標籤嗎？',
  EMPTY_URL: '影片網站輸入欄不能為空白',
  EXCEED_MAX_COMPONENT: '內容數量已達上限，無法再新增。',
  EXCEED_MAX_HOTSPOT: 'EXCEED_MAX_HOTSPOT',
  REMARK: '備註',
  ACTION: '操作',
  EXIT: '離開',
  EXPLORE: '探索',
  LOCATE_ON_MAP: '在地圖中定位',
  SHOW_CARD_SUBJECTS: '顯示科目',
  LOCALE_SETTINGS: 'LOCALE 設定',
  LOCALE_SETTINGS_PUBLISHING: '公布設定',
  LOCALE_SETTINGS_HOTSPOT_UNLOCK: '熱點解鎖',
  LOCALE_SETTINGS_GAME_MODE: '遊戲模式',
  LOCALE_SETTINGS_AI_FEATURES: 'AI功能',
  FILE_TYPE: '檔案類型',
  FILL_AT_LEAST_ONE: '請填寫最少一個文字框',
  FILL_IN_MIND_MAP: '概念圖填充題',
  FILL_IN_MIND_MAP_DESCRIPTION: '請填寫概念圖',
  FILL_IN_THE_BLANK: '填充',
  FILL_IN_THE_BLANK_DESCRIPTION: '請填上合適的答案',
  FINISH: '完成',
  HOTSPOT_CONTENT_3D_MODEL: '3D模型',
  HOTSPOT_CONTENT_3D_MODEL_DESCRIPTION: '上傳並顯示3D模型內容',
  HOTSPOT_CONTENT_3D_MODEL_PREVIEW: '3D模型預覽',
  HOTSPOT_CONTENT_3D_MODEL_GENERATING: '3D模型生成需要5－10分鐘，過程中可以離開這對話框，生成進度不會受影響。',
  NO_3D_QUOTA_CONTACT_ADMIN: '沒有剩餘 3D 模型配額，請購買新的配額。',
  REMAINING_QUOTA: '剩餘配額',
  THIS_IS_3D_MODEL_TIP: '此區域為3D模型預覽。',
  NO_3D_MODEL_YET: '3D模型正在生成中。',
  NO_IMAGE_UPLOADED_YET: '請在左側上傳圖片以開始生成3D模型。',
  GENERATE_3D_MODEL: '生成3D模型',
  GENERATING_3D_MODEL: '正在生成3D模型…',
  PLEASE_SUBMIT_TO_GENERATE_3D_MODEL: '請提交生成3D模型',
  CHECKING_FOR_3D_UPDATE: '正在檢查3D模型更新…',
  DOWNLOAD_GLB: '下載GLB',
  VIEW_3D_FULLSCREEN: '全螢幕顯示',
  EXIT_3D_FULLSCREEN: '退出全螢幕',
  PREVIEW_IMAGE: '預覽圖片：',
  MODEL_3D_LOADED_SUCCESS: '3D模型載入成功！',
  MODEL_3D_LOAD_FAILED: '載入3D模型失敗',
  MODEL_3D_NO_AVAILABLE: '沒有可查看的3D模型。',
  MODEL_3D_DEFAULT_NAME: '3D模型',
  UPLOAD_IMAGE_TO_GENERATE_3D: '上傳圖片以開始生成3D模型',
  GEN3D_UPLOAD_INFO: '最佳效果：單一物件、清晰且光線充足、背景乾淨。透明背景的PNG效果最好。上傳後請在右方設定參數，然後按「生成3D模型」。',
  GEN3D_SETTINGS: '3D生成設定',
  GEN3D_HOW_IT_WORKS: '上傳單一物件的相片，設定右方參數後按「生成3D模型」，需時約5–10分鐘。你可以關閉此視窗，生成會在背景繼續；地圖右上角的圖示會顯示進度，點擊可返回此處。',
  GEN3D_PARAMS_LOCKED: '生成期間不能修改設定；以下是這次生成使用的參數。',
  GEN3D_NO_PRIVILEGE: '此學校未啟用3D模型生成，或訂閱未生效／已過期，請聯絡管理員。',
  GEN3D_QUOTA_UNKNOWN: '暫時無法讀取剩餘配額；仍可嘗試生成，由伺服器作最後檢查。',
  GEN3D_START_REQUIRED: '請先按「生成3D模型」開始生成，才能儲存此3D組件。',
  GEN3D_PROMPT_LABEL: '材質／風格提示',
  GEN3D_PROMPT_INFO: '描述物件的材質與顏色（例如「光面陶瓷」、「啞光塑膠」、「拉絲金屬」），可改善生成貼圖的效果。可留空。',
  GEN3D_PROMPT_PLACEHOLDER: '例如：光面陶瓷茶壺，深綠色',
  GEN3D_ENGINE_LABEL: '生成引擎',
  GEN3D_ENGINE_INFO: '選擇生成模型的內建引擎。標準：品質全面、PBR貼圖真實（預設）。備選：另一引擎，效果不理想時可轉用比較。',
  GEN3D_ENGINE_STANDARD: '標準',
  GEN3D_ENGINE_ALTERNATIVE: '備選',
  GEN3D_SELF_PROGRESS: '正在以內建引擎生成3D模型…',
  GEN3D_QUOTA_TOOLTIP: '此訂閱尚可生成 {0} 個3D模型（總配額 {1}）。每次成功生成（不論使用哪個引擎）會使用一個配額；用完後請聯絡管理員。',
  GEN3D_QUALITY_LABEL: '模型品質',
  GEN3D_QUALITY_INFO: '生成的模型儲存前都會先壓縮，讓學生裝置更快載入。高：保留最多細節；中／低：檔案更小（面數更少、貼圖更小），載入更快。',
  GEN3D_QUALITY_HIGH: '高',
  GEN3D_QUALITY_MID: '中',
  GEN3D_QUALITY_LOW: '低',
  GEN3D_OPTIMIZING: '正在壓縮模型…',
  GEN3D_MODE_SELF: '內建引擎',
  GEN3D_MODE_CLOUD: '雲端服務',
  GEN3D_TIER_LABEL: '生成品質',
  GEN3D_TIER_INFO: '適用於雲端生成（以及自動雲端備援）。標準：品質與速度平衡；快速：更快但較簡單；專業：可在下方微調面數與類型。',
  GEN3D_TIER_STANDARD: '標準',
  GEN3D_TIER_RAPID: '快速',
  GEN3D_TIER_PRO: '專業',
  GEN3D_PBR_LABEL: 'PBR材質',
  GEN3D_PBR_INFO: '物理擬真材質（金屬度／粗糙度），令表面更真實。建議開啟。',
  GEN3D_FACE_COUNT_LABEL: '面數上限',
  GEN3D_FACE_COUNT_INFO: '模型多邊形數量上限（僅專業品質適用）。面數越多細節越多，但檔案越大，學生裝置載入越慢。',
  GEN3D_TYPE_LABEL: '生成類型',
  GEN3D_TYPE_INFO: 'Normal保留完整細節；LowPoly生成較輕量的風格化模型，載入更快（僅專業品質適用）。',
  GEN3D_TYPE_NORMAL: '標準',
  GEN3D_TYPE_LOWPOLY: '低面數',
  GEN3D_PHASE_SUBMITTING: '正在提交…',
  GEN3D_PHASE_QUEUED: '等待伺服器中…',
  GEN3D_PHASE_PREPARING: '準備中…',
  GEN3D_PHASE_GENERATING: '正在生成3D模型…',
  GEN3D_PHASE_FINALIZING: '收尾中…',
  GEN3D_PHASE_IMPORTING: '正在儲存模型…',
  GEN3D_PHASE_CLOUD: '雲端生成中…',
  GEN3D_PHASE_FAILED: '生成失敗',
  GEN3D_SLOW_NOTE: '比平時需時更久——仍在處理中…',
  GEN3D_BG_REMINDER: '可以關閉此視窗，生成會在背景繼續進行。地圖右上角的圖示會顯示進度，點擊即可返回此處。',
  GEN3D_FALLBACK_NOTICE: '內建引擎暫時無法使用，已自動改用雲端生成。',
  GEN3D_READY_NOTICE: '3D模型已生成完成。',
  GEN3D_RETRY: '重試',
  GEN3D_CANCEL: '取消生成',
  GEN3D_CANCEL_CONFIRM_TITLE: '取消3D生成',
  GEN3D_CANCEL_CONFIRM_BODY: '確定要停止生成這個3D模型嗎？來源圖片亦會一併移除，之後可重新上傳圖片開始新的生成。',
  GEN3D_CANCELLED: '已取消3D生成。',
  GEN3D_CANCELLED_REMOTE: '3D生成已在伺服器端取消。',
  GEN3D_DELETE_MODEL: '刪除',
  GEN3D_DELETE_CONFIRM_TITLE: '刪除3D模型',
  GEN3D_DELETE_CONFIRM_BODY: '確定要刪除這個3D模型嗎？模型與來源圖片將一併移除，之後可重新上傳圖片再次生成。已使用的配額不會退還。',
  GEN3D_DELETED: '已刪除3D模型。',
  GEN3D_PHASE_CANCELLED: '已取消生成',
  GEN3D_REGENERATE: '重新生成',
  GEN3D_CANCELLED_HINT: '如有需要可先調整上方設定，再按「重新生成」。更換圖片亦會重新開始生成。',
  GEN3D_JOBS_IN_PROGRESS: '{0}個3D模型生成中',
  GEN3D_JOB_OPEN_HINT: '點擊查看進度',
  GEN3D_CLEANUP: '清理',
  GEN3D_CLEANUP_RUNNING: '檢查中…',
  GEN3D_CLEANUP_HINT: '向伺服器核對每個工作，移除已取消或已完成的項目。',
  FORGET_PASSWORD: '忘記密碼',
  GET_TRANSCRIPTION: '獲取轉錄',
  HOTSPOT_INVISIBLE: '隱藏熱點',
  HOTSPOT_LIST: '熱點列表',
  HOTSPOT_EDIT: '編輯熱點內容',
  HOTSPOT_EDIT_REMINDER_1: '本熱點的位置及內容尚未設定，確定離開嗎？',
  HOTSPOT_EDIT_REMINDER_2: '確定離開嗎？',
  HOTSPOT_EMPTY_NAME_REMINDER: '熱點名字不能為空白',
  HOTSPOT_VISIBILITY: '顯示熱點',
  HOTSPOT_VISIBLE: '正常顯示',
  IMAGE_NOT_FILLED: '未上傳圖片，確定離開嗎？',
  IMAGE_REQUIRED: '請上傳圖片',
  IMAGE_SEARCH: '搜尋圖片',
  INPUT_KEYWORD: '輸入關鍵字',
  KEYWORD: '關鍵字',
  KLA_FULL: '學習領域 KLA',
  KLA_SHORT: '學習領域',
  LANGUAGE: '語言',
  LANGUAGE_ENGLISH_HELPER: '將 composer 介面顯示為英文。',
  LANGUAGE_ENGLISH_LABEL: 'English',
  LAST_LOGIN_TIME: '上次登入時間',
  LATEST_SUBMISSION: '最近遞交時間',
  LATITUDE: '緯度',
  LINK_OTHER_MIND_MAP_BOX: '連結其他概念圖方塊',
  LOCALE_COVER_BLANK_REMINDER: '請上載一張封面圖片',
  LOCALE_KLA_BLANK_REMINDER: '請選擇一個學習領域',
  LOCALE_MAP_BLANK_REMINDER: '請設定考察範圍',
  LOCALE_MAP_MAX_SIZE_REMINDER: '考察範圍太廣（長／寬大於三十公里），建議縮小考察範圍',
  LOCALE_MAP_MIN_SIZE_REMINDER: '考察範圍太窄（長／寬小於一千米）',
  LOCALE_MAP_ZOOM_LV_REMINDER: '地圖縮放度太小，不適合考察，建議設放大地圖',
  LOCALE_NAME_BLANK_REMINDER: '名稱不能為空白',
  LOCALE_SEARCH_RESULT_NONE: '未有符合條件的考察教件，請嘗試以其他條件搜尋',
  LOCALE_SEARCH_TEXT_PLACEHOLDER: '關鍵字或學校名稱',
  LOCALE_SUBJECT_BLANK_REMINDER: '請選擇一個學科',
  LOCATION: '設定考察範圍',
  LOCATION_SEARCH: '地點搜尋',
  LOGIN: '登入',
  LOGOUT: '登出',
  
  LONGITUDE: '經度',
  MAP_SIZE: '地圖大小 (闊*高)',
  MATCHVIEW_REMINDER: '把考察範圍設定成與當前地圖視窗大致相似的區域',
  DEFINE_FIELD_TRIP_AREA: '放置考察區域',
  MC_OF_PICTURES: '圖片選擇題',
  MC_OF_PICTURES_DESCRIPTION: '請選擇最合適的圖片答案',
  MC_OF_PICTURES_MULTI: '圖片多項選擇題',
  MC_OF_PICTURES_MULTI_DESCRIPTION: '請選擇多個圖片答案',
  MC_OF_TEXTS: '文字選擇題',
  MC_OF_TEXTS_DESCRIPTION: '請選擇最合適的文字答案',
  MC_OF_TEXTS_MULTI: '文字多項選擇題',
  MC_OF_TEXTS_MULTI_DESCRIPTION: '請選擇多個文字答案',
  MIND_MAP_BOX: '方塊',
  MIND_MAP_FILL_IN_BOX: '填充方塊',
  MIND_MAP_LABLE_BOX: '描述方塊',
  MOVE_DOWN: '向下移',
  MOVE_UP: '向上移',
  MOVIECLIP: '短片',
  MOVIECLIP_URL: '影片網站',
  MOVIECLIP_DESCRIPTION: '播放短片',
  MOVIECLIP_SOURCE: '短片來源',
  MOVIECLIP_TAB_YOUTUBE: 'YouTube 網址',
  MOVIECLIP_TAB_UPLOAD: '上載影片',
  MOVIECLIP_UPLOAD_INSTRUCTION: 'MP4 影片，H.264 + AAC，最大 200MB。\n上載的影片會隨 LOCALE 一併下載，可離線播放。',
  MOVIECLIP_APP_VERSION_NOTICE: '上載影片需要 EduVenture-AI 應用程式 %s 或以上版本。使用舊版應用程式的學生將無法播放此短片；如需支援舊版本，請改用 YouTube 網址。',
  MOVIECLIP_SWITCH_TITLE: '更改影片來源',
  MOVIECLIP_SWITCH_TO_YOUTUBE: '短片只能使用上載影片或 YouTube 網址其中一種。切換至 YouTube 將會刪除已上載的影片。',
  MOVIECLIP_SWITCH_TO_UPLOAD: '短片只能使用上載影片或 YouTube 網址其中一種。切換至上載影片將會清除 YouTube 網址。',
  VIDEO_NOT_UPLOADED: '請上載影片，或切換至 YouTube 網址',
  MY_SCHOOL: '我的學校',
  NAME: '名稱',
  NEW_HOTSPOT: '新熱點',
  TRANSLATE: '翻譯',
  TRANSLATE_LOCALE_TITLE: '翻譯考察教件',
  TRANSLATE_SELECT_LANGUAGE: '選擇要將此考察教件的所有文字（名稱、所有熱點及其內容）翻譯成的語言：',
  LANG_TRADITIONAL_CHINESE: '繁體中文',
  LANG_SIMPLIFIED_CHINESE: '簡體中文',
  LANG_ENGLISH: '英文',
  TRANSLATE_OVERWRITE_WARNING: '此操作會直接覆蓋現有文字。如要保留原文，請先複製此考察教件。',
  TRANSLATE_CONFIRM_PROMPT: '確定要將此考察教件的所有文字翻譯成{0}嗎？此操作會直接覆蓋現有文字，且無法復原。',
  TRANSLATE_CONFIRM: '翻譯',
  TRANSLATING: '翻譯中⋯⋯請稍候。',
  TRANSLATE_SUCCESS: '翻譯完成（已更新 {0} 個項目）。',
  TRANSLATE_FAILED: '翻譯失敗，請再試一次。',
  NEW_LOCALE: '新考察教件',
  NEW_PASSWORD: '新密碼',
  NEXT: '下一步',
  NEXT_PAGE: '下一頁',
  NO: '否',
  NO_ANSWER_NEEDED: "不用作答",
  NO_ANSWER: '未有答案',
  NO_DRAWING: '未有繪圖',
  NO_PHOTO: '未有拍攝',
  NO_RECORDING: '未錄音',
  NO_RESOURCES_IN_CATEGORY: '此類別中沒有資源。',
  NOT_POSITIONED: '未設定位置',
  NO_CONTENT: '沒內容',
  NTH_FILLED: '未填寫任何內容',
  OK: '好',
  OLD_PASSWORD: '舊密碼',
  OLD_PASSWORD_NOT_CORRECT: '舊密碼不正確',
  ONLY_SUPPORT_VIDEO: '請輸入有效的Youtube影片網址',
  OVERVIEW: '考察教件概覽',
  OWN_SUBMISSION: '檢視已提交答案的教件',
  PAGE: '跳至頁數',
  PASSWORD: '密碼',
  PASSWORD_REQUIREMENT_0: '重新輸入的密碼不正確',
  PASSWORD_REQUIREMENT_1: '字元無效，只可使用字母和數字',
  PASSWORD_REQUIREMENT_2: '密碼只可包含字母和數字',
  PASSWORD_REQUIREMENT_3: '密碼長度須超過6個字元',
  PASSWORD_REQUIREMENT_4: '密碼長度不可超過30個字元',
  PASSWORD_REQUIREMENT_5: '密碼不能為空白',
  PASSWORD_UPDATED: '密碼已更新',
  PASSWORD_UPDATE_FAIL: '密碼更新失敗，請檢查你的舊密碼',
  PLEASE_SELECT: '請選擇',
  POSITION: '位置',
  POSITIONTED: '已選定位置',
  PREPARING: '準備中',
  PREVIOUS_PAGE: '上一頁',
  PROFILE: '個人資料',
  PROGRESS: '進度',
  PUBLIC: '公開',
  PUBLISH: '發布',
  QR_CODE: 'QR Code',
  QR_CODE_DESC: '生成 QR Code 供學生掃描，在App中打開此考察教件',
  DOWNLOAD_QR_CODE: '下載 QR Code',
  QR_CODE_PLATFORM_HINT: 'iOS 及 Android 裝置均可掃描；尚未安裝 App 的學生會看到下載連結。',
  QR_CODE_UNPUBLISHED_WARNING: '此考察教件尚未發布。學生掃描此 QR Code 後只會顯示找不到考察教件。',
  QR_CODE_PUBLISH_PROMPT: '此考察教件尚未發布，學生掃描 QR Code 後只會顯示找不到考察教件。要立即發布並顯示 QR Code 嗎？',
  QR_CODE_PUBLISH_CONFIRM: '發布並顯示 QR Code',
  QR_CODE_PUBLISHED: '已發布此考察教件',
  QR_CODE_PUBLISH_FAILED: '無法發布此考察教件，因此未顯示 QR Code。請再試一次；如持續失敗，請確認你有編輯權限，以及學校訂閱仍然有效。',
  QR_CODE_PENDING_UNPUBLISH_WARNING: '你已關閉「發布」。此 QR Code 現在仍可使用，但儲存後便會失效。',
  QUESTION: '問題',
  QUESTION_DESCRIPTION: '文字或圖片短答問題',
  QUESTION_NOT_FILLED: '未填寫問題',
  RADIUS: '半徑',
  RE_ENTER_NEW_PASSWORD: '再次輸入新密碼',
  READY: '就緒',
  REFRESH: '刷新',
  REPORT_BUG: '匯報漏洞',
  REPORT_BUG_REMINDER: '請匯報漏洞',
  RETRIEVE_ANSWERS: '查看學生答案',
  ROW: '行',
  ROW_COL_NOT_FILLED: '未填寫行／欄名稱',
  SAFE_IMAGE_SEARCH: '安全搜尋圖片',
  SAVE: '儲存',
  SCHOOL: '學校',
  SCHOOL_LIST: '學校列表',
  SCHOOL_NAME: '學校名稱',
  SEARCH: '搜尋',
  SEARCH_LOCATION: '搜尋地方',
  SELECT: '選擇',
  SELECT_AI_MODEL: 'AI模型',
  SELECT_IMAGE: '選擇圖片',
  SET_POSITION: '設定位置',
  SETTINGS: '設定',
  LANGUAGE_TRADITIONAL_CHINESE_LABEL: '繁體中文',
  LANGUAGE_TRADITIONAL_CHINESE_HELPER: '將 composer 介面顯示為繁體中文。',
  SHARABLE: '共享',
  SHARE: '分享',
  SHARE_SUBMISSION: '啓用分享連結',
  SHARE_SUBMISSION_CONFIRM_MESSAGE: '啓用分享連結後，任何人擁有連結都可檢視答案。你確定嗎？',
  SHARING_URL: '分享網址',
  SIMPLE_DESCRIPTION: '圖文描述',
  SIMPLE_DESCRIPTION_DESCRIPTION: '簡單圖文描述',
  SORT_BY: '排序',
  SORT_CREATE_DATE_ASC: '由最早建立',
  SORT_CREATE_DATE_DESC: '由最近建立',
  SORT_MODIFY_DATE_ASC: '由最早更新',
  SORT_MODIFY_DATE_DESC: '由最近更新',
  SORT_NAME_ASC: '名稱 (A-Z)',
  SORT_DOWNLOAD_COUNT_ASC: '最少下載次數',
  SORT_DOWNLOAD_COUNT_DESC: '最多下載次數',
  STORAGE: '儲存空間',
  SUBJECT: '學科',
  SUBMISSION_DATE: '提交日期',
  SUBMISSION_P: '遞交人數',
  SUBMISSION_S: '遞交數量',
  SUBMISSION_TIME: '遞交時間',
  SUBMISSION_SORT_TIME_DESC: '提交時間（晚至早）',
  SUBMISSION_SORT_TIME_ASC: '提交時間（早至晚）',
  SUBMISSION_SORT_SCORE_DESC: '分數（高至低）',
  SUBMISSION_SORT_SCORE_ASC: '分數（低至高）',
  SUBMIT: '遞交',
  SUBMITTED: '已遞交',
  SWITCH_BACK_TO_CLASSIC_UI: '經典用戶界面',
  SWITCH_TO_LIST: '切換至列表',
  SWITCH_TO_MAP: '切換至地圖',
  TABLE_AND_CELL: '新增表格',
  TABLE_AND_CELL_DESCRIPTION: '新增表格題目 / 統計題目',
  TAKE_PHOTO: '拍照題',
  TAKE_PHOTO_DESCRIPTION: '要求拍攝',
  TAKE_RECORD: '錄音 / 訪問',
  TAKE_RECORD_DESCRIPTION: '要求錄音',
  DRAWING_TASK: '繪圖題',
  DRAWING_TASK_DESCRIPTION: '學生以繪圖作答',
  TELEPORT: '移至考察區域',
  TELEPORT_REMINDER: '若考察範圍在地圖視窗外，把地圖視窗移動至考察範圍',
  TIME: '時間',
  TITLE: '標題',
  TOO_NARROW_REMINDER: '考察範圍太小，建議邊長1KM以上',
  TOO_WIDE_REMINDER: '距離太長（最大三十公里），建議縮小考察範圍',
  UNSPECIFIED_SUBJECT: '沒特定科目',
  UNSAVED_CHANGES: '未儲存變更',
  UNSAVED_REMINDER: '已有一些輸入內容，你確定要取消嗎？所有變更將會丟失。',
  UPDATE: '更新',
  UPDATE_FAILED: '更新失敗',
  UPDATE_PASSWORD: '更新密碼',
  UPDATE_PROFILE: '更新個人資料',
  UPDATED: '已更新',
  UPLOAD: '上載',
  UPLOAD_COMPLETE: '上載完成',
  UPLOAD_FAILED: '上載失敗',
  UPLOAD_FILE_SIZE_REMINDER: '檔案大小須小於',
  UPLOAD_FILE_TYPE_REMINDER: '不允許的檔案類型',
  UPLOAD_FILE: '上載檔案',
  // FilePicker 的 `document` 預覽（預製教材範本的教師參考手冊）：PDF 沒有
  // 可用的內嵌預覽，故顯示檔案名稱與開啟連結，而非會變成破圖的 <img>。
  // 學校密鑰，顯示於帳戶選單的學校名稱旁。學生需輸入此密鑰才能取得本校的
  // LOCALE，故提示說明其用途而非僅其名稱。
  SCHOOL_KEY: '學校密鑰',
  SCHOOL_KEY_HINT: '學校密鑰 — 學生需輸入此密鑰加入貴校',
  // 分成前後兩段，令密鑰本身可用等寬字型顯示（密鑰混合數字與英文字母，
  // 常需口述或手抄）。顯示為「(學校密鑰: 9881)」。
  SCHOOL_KEY_LABEL_OPEN: '(學校密鑰: ',
  SCHOOL_KEY_LABEL_CLOSE: ')',
  UPLOADED_FILE: '已上載檔案',
  OPEN_FILE: '開啟',
  RECORD_AUDIO: '錄音',
  START_RECORDING: '開始錄音',
  STOP_RECORDING: '停止',
  USE_RECORDING: '使用此錄音',
  RE_RECORD: '重新錄音',
  PROCESSING_RECORDING: '正在處理錄音',
  RECORDING_FAILED: '錄音失敗，請再試一次。',
  RECORDING_NOT_SUPPORTED: '此瀏覽器不支援錄音功能。',
  MICROPHONE_ACCESS_DENIED: '麥克風存取被拒絕，請允許使用麥克風後再試一次。',
  RECORDING_MAX_LENGTH_REACHED: '已達到最長錄音時間。',
  UPLOAD_LOCAL_FILE: '上載本機檔案',
  UPLOAD_SCREENSHOT: '上載截圖',
  UPLOADED: '已上載',
  UPLOADING: '上載中',
  USER_CHOICE_TAG: '[已選擇]',
  USER_INFORMATION: '用戶資料',
  USER_LIST: '用戶列表',
  USER_ROLE: '用戶角色',
  USER_ROLE_TEACHER_LOW: '一般用戶',
  USER_ROLE_TEACHER_STANDARD: '進階用戶',
  USER_ROLE_ADMINISTRATOR: '管理員',
  USER_ROLE_UNKNOWN: '未知角色',
  USERNAME: '用戶名稱',
  VIEW_AI_RESPONSES_HISTORY: '檢視AI生成紀錄',
  VIEW_AI_RESPONSE_HISTORY: '檢視AI生成紀錄',
  VIEW_EDIT_DETAILS: '查看 / 編輯細節',
  VOICE_NOT_FILLED: '未上傳MP3音檔',
  VOICE_OVER: '聲音導航',
  VOICE_OVER_DESCRIPTION: '播放MP3音檔',
  VOICE_TRANSCRIPTION: '語音轉文字',
  VOICE_TRANSCRIPTION_INSTRUCTION: '從已上載的音檔產生文字。你可以編輯轉換結果。',
  VOICE_NO_AUDIO: '請先上載或錄製音檔。',
  TRANSCRIBE: '轉換文字',
  TRANSCRIBING: '轉換中...',
  TRANSCRIBE_DONE: '已完成語音轉文字',
  TRANSCRIBE_FAILED: '語音轉文字失敗，請再試一次。',
  YES: '是',
  YOUTUBE_ID_INVALID: '無效的Youtube網站',
  YOUTUBE_URL_TOO_LONG: '影片網址太長',
  ZOOM: '縮放',
  ZOOM_IN: '放大',
  ZOOM_OUT: '縮小',
  MAP_MONO: '單色',
  MAP_SATELLITE: '衛星',
  MAP_VECTOR: '向量',
  LOCALE_LIST: 'LOCALE 列表',
  EMAIL_CAN_BE_USED_AS_LOGIN: '電郵可以用作登入名稱及找回密碼',
  SUBMIT_BUG_REPORT: '問題報告將會由Google Form收集，確定開啟另一個網頁並提交問題報告？',
  PUBLIC_LOCALE_ONLY: '只檢閱公開考察教件',
  QA_STATE: '審檢狀態',
  QA_STATE_ANY: '所有',
  QA_STATE_UNCHECKED: '未審檢',
  QA_STATE_CHECKED: '已審檢',
  QA_STATE_MINOR: '小問題',
  QA_STATE_MAJOR: '大問題',
  RETRIEVER: 'RETRIEVER 收集答案工具',
  DROP_FILE_HERE_OR_CLICK_TO_SELECT: '按這裡選擇上傳檔案（支援檔案拖放）',
  UPDATED_DATE: '更新時間',
  CREATED_DATE: '創建時間',
  MOVE_TO_HOTSPOT_LOCATION: '移至熱點位置',
  MOVE_TO_HOTSPOT_LOCATION_REMINDER: '地圖視窗會跳到熱點所在位置',
  HOTSPOT_HAS_LOCATION: '已設好熱點位置',
  METER: '米',
  REVEAL_CODE: "解鎖代碼",
  REVEAL_CODE_REQUIREMENT_0: "字元無效，只可使用字母和數字",
  REVEAL_CODE_REQUIREMENT_1: "代碼必須包含字母和數字(6個字元)",
  REVEAL_CODE_REQUIREMENT_2: "代碼必須包含6個字元",
  REVEAL_CODE_REQUIREMENT_3: "代碼不能為空白",
  USE_REVEAL_CODE: "使用熱點解鎖代碼",
  ENABLE_REVEAL_CODE: "啟用解鎖代碼",
  ENABLE_REVEAL_CODE_MESSAGE: "在EduVenture-AI應用程序中輸入代碼來解鎖所有熱點。",
  DISABLE_REVEAL_CODE_MESSAGE: "不能在EduVenture-AI應用程序中輸入代碼來解鎖所有熱點。",
  REVEAL_CODE_HINT: "啟用後可在EduVenture-AI中輸入代碼解鎖所有熱點",
  AUTO_SHARE_ASSESSMENT: "分發評估給學生",
  AUTO_SHARE_VIA_DEVICE: "AI完成評估後發送",
  AUTO_SHARE_VIA_EDCITY: "透過EdCity完成評估後發送給學生",
  AUTO_SHARE_VIA_BOTH: "透過裝置和EdCity完成評估後發送給學生",
  AUTO_SHARE_ASSESSMENT_HELP: "AI評估完成後自動將評估結果分享給學生",
  AVATAR_INTERACTION: "頭像互動（遊戲模式）",
  AVATAR_INTERACTION_APP_VERSION_REQUIRED: "此功能需要在 v2.0.4 或更新的EduVenture-AI應用程式版本啟用。",
  MOOD_ENABLED: "Emoji 狀態",
  MOOD_ENABLED_HELP: "啟用後，學生可在遊戲模式中設定自己的 Emoji 狀態，並可點按其他學生的頭像查看其 Emoji 狀態。",
  NUDGE_ENABLED: "震動",
  NUDGE_ENABLED_HELP: "啟用後，點按其他學生的頭像可使其裝置震動。震動設有次數限制並會記錄。",
  CHAT_TEACHER_TO_STUDENT: "聊天：教師至學生",
  CHAT_STUDENT_TO_STUDENT: "聊天：學生至學生",
  CHAT_STUDENT_TO_TEACHER: "聊天：學生至教師",
  CHAT_TEACHER_TO_STUDENT_HELP: "啟用後，教師可在遊戲模式中與學生開始對話。",
  CHAT_STUDENT_TO_STUDENT_HELP: "啟用後，學生可在遊戲模式中互相聊天。教師可查看所有對話內容，學生亦會收到相關提示。",
  CHAT_STUDENT_TO_TEACHER_HELP: "啟用後，學生可在遊戲模式中與教師開始對話。",
  MANUALLY: "手動",
  AUTOMATICALLY: "自動",
  AI_ASSESSMENT_MODE_HELP: "手動：由教師在「收集答案工具」按「執行AI評估」按鈕啟動AI評估。自動：學生提交後系統自動執行AI評估。",
  RUN_AI_ASSESSMENT: "執行AI評估",
  ALL_AI_QUESTIONS_COMPLETED: "所有AI評估問題已完成。",
  AI_ASSESSMENT_QUEUED_OK: "已開始AI評估，已加入 {0} 個答案。",
  AI_ASSESSMENT_QUEUED_FAIL: "無法開始AI評估。",
  NEW_APP_VERSION_REQUIRED: "此功能只能在 v1.5.0 或更新的EduVenture-AI應用程式版本開啟。",
  VOICE_TO_TEXT: "語音轉文字",
  PREMIUM_FEATURE_VOICE_TO_TEXT: "請升級您的訂閱以使用語音轉文字功能",
  UPGRADE_TO_PREMIUM: "目前功能受訂閱方案限制，建議升級以解鎖更多功能",
  AI_TEXT_TRANSCRIPTION: "AI語音轉文字",
  RE_RUN_VOICE_TO_TEXT: "重新語音轉文字",
  BACK_TO_AND_CHOOSE: "返回並選擇",
  SUBSCRIPTION: "訂閱",
  MAX_SCORE: "題目分數",
  MAX_SCORE_HINT: "設定題目學生可得的最高分數。",
  NOT_GRADED: "不計分",
  MARKING_SCHEME: "評分標準",
  AI_MARKING_SCHEME: "AI自動評估 評分標準",
  MARKING_SCHEME_INSTRUCTION: "輸入「正確答案」可啓用AI自動評估。AI 會根據「正確答案」評分，「排除答案」及「其他指引」可按需要填寫（可留空），以提升AI自動評估的準確性。",
  MARKING_SCHEME_AI_HINT: "AI 會根據「正確答案」及「其他指引」自動評估學生答案。請使用清晰、具體的描述，以提升 AI 評估準確度。",
  ANSWER_TO_EXCLUDE: "排除答案",
  OTHER_GUIDELINES: "其他指引",
  SUBMIT_TO_AI: "提交給AI",
  STORAGE_LIMIT_REACHED: "儲存空間已達上限",
  STORAGE_LIMIT_MESSAGE: "儲存空間已達上限，請管理或升級您的訂閱。",
  OPEN_SUBSCRIPTION_PAGE: "前往訂閱頁面",
  LOCALE_LIMIT_REACHED: "教件數量已達上限",
  LOCALE_LIMIT_MESSAGE: "您已達到訂閱計劃中可建立的教件數量上限。",
  LOCALE_EDIT_BLOCKED_TITLE: "無法編輯教件",
  LOCALE_EDIT_BLOCKED_MESSAGE: "貴校現時沒有生效的訂閱，因此無法編輯現有教件。瀏覽教件及查閱學生答案不受影響。",
  LOCALE_EDIT_BLOCKED_TOOLTIP: "沒有生效的訂閱，無法編輯",
  LOCALE_CREATE_BLOCKED_TITLE: "無法建立教件",
  LOCALE_CREATE_BLOCKED_MESSAGE: "貴校現時沒有生效的訂閱，可建立的教件數量為 0，因此無法建立新教件。現有教件及學生答案仍可查閱。",
  // 教件配額提示 — 只向 eLAFP 基本版學校顯示，詳見 tools/localeQuotaNotice.js
  LOCALE_QUOTA_DEDUCT_CREATE_NOTICE: "注意：建立此教件將扣除貴校 1 個教件配額。",
  LOCALE_QUOTA_DEDUCT_DUPLICATE_NOTICE: "注意：複製此教件將扣除貴校 1 個教件配額。",
  LOCALE_QUOTA_NO_REFUND_NOTICE: "注意：刪除教件後，建立時已扣除的教件配額不會退回。",
  // 上面兩句的「帶數字」版本，只在餘額已知且伺服器真的會扣帳時使用；
  // 餘額未知時沿用不帶數字的句子。{0} = 現時餘額，{1} = 扣除後餘額。
  LOCALE_QUOTA_DEDUCT_CREATE_NOTICE_WITH_QUOTA: "注意：建立此教件將扣除貴校 1 個教件配額（由 {0} 減至 {1}）。",
  LOCALE_QUOTA_DEDUCT_DUPLICATE_NOTICE_WITH_QUOTA: "注意：複製此教件將扣除貴校 1 個教件配額（由 {0} 減至 {1}）。",
  DUPLICATE_NOT_ALLOWED_TITLE: "不允許複製",
  DUPLICATE_NOT_ALLOWED_MESSAGE: "您當前的訂閱不允許複製資源。",
  // 伺服器拒絕寫入時顯示的句子 — 對應表見 tools/serverErrorKey.js。
  // 未能對應的伺服器訊息只寫入 console，改為顯示各流程本身的通用句子，
  // 絕不把伺服器的英文原文顯示給用戶。
  DUPLICATE_FAILED: "複製失敗。",
  DUPLICATE_SUCCESS: "已複製為 LOCALE ID：{0}。",
  DUPLICATE_SOURCE_UNAVAILABLE_MESSAGE: "無法複製此教件：其擁有者未允許複製，或該教件已不存在。請重新整理資源庫。",
  LOCALE_GONE_MESSAGE: "此教件已不存在，可能已被刪除。請重新整理列表。",
  LOCALE_CREATED_COVER_LINK_FAILED: "教件已建立，但封面圖片未能連結至教件。",
  LOCALE_QUOTA_CHECK_FAILED: "無法檢查教件配額，請稍後再試。",
  RESOURCE_LIBRARY_LOAD_FAILED: "載入資源庫失敗，請稍後再試。",
  SERVER_REJECTED_INPUT: "部分欄位未能儲存，請檢查名稱及描述（不支援表情符號）。",
  SERVER_BUSY_RETRY: "伺服器繁忙，請稍後再試。",
  NETWORK_ERROR: "無法連接伺服器，請檢查網絡連線後再試。",
  AI_ASSESSMENT_RESULT: "AI評估結果",
  OLD_PASSWORD_HELPER: "您的原始密碼",
  NEW_PASSWORD_HELPER: "新密碼應包含字母和數字",
  CONFIRM_PASSWORD_HELPER: "重新輸入新密碼",
  DUPLICATION_RULE: "複製規則",
  DUPLICATION_RULE_0: "不允許複製",
  DUPLICATION_RULE_1: "允許相同學校的用戶複製",
  DUPLICATION_RULE_2: "允許其他用戶複製",
  DUPLICATION_RULE_3: "允許任何人複製",
  DUPLICATION_RULE_HINT: "設定誰可以複製此資源",
  DUPLICATION_NOT_ALLOWED_HINT: "這是複製的教件，只限本校使用",
  SCHOOL_ONLY_USE: "限本校使用",
  RESOURCE_LIBRARY: "資源庫",
  DOWNLOAD_ANSWER: '下載答案',
  ANSWER_OF_LOCALE: '的答案',
  TOTAL: '共',
  MY_LOCALE: "我的 LOCALE",
  SCHOOL_LOCALE_DUPLICATABLE: "可複製的同校 LOCALE",
  OTHER_LOCALE_DUPLICATABLE: "可複製的其他 LOCALE",
  DUPLICATE: "複製",
  CONFIRM_DUPLICATION: "確認複製",
  DUPLICATION_CONFIRM_MESSAGE: "您即將複製電子學習包：{0}。此操作將在您的帳戶下創建一個全新的獨立副本。請在下方輸入新電子學習包的名稱。",
  NEW_LOCALE_NAME: "新電子學習包名稱",
  DUPLICATION_NAME_HINT: "如果留空，名稱將是原始名稱加上「（副本）」後綴。",
  CONFIRM: "確認",
  LAST_UPDATE: "最後更新",
  DUPLICATABLE_LOCALE_TITLE: "可供複製的LOCALE",
  CREATE_NEW_LOCALE: "創建新LOCALE",
  LIST_VIEW: "列表檢視",
  MAP_VIEW: "地圖檢視",
  DUPLICATABLE_LIBRARY: "可複製資源庫",
  AI_ASSESSMENT: "AI評估",
  PREMIUM_FEATURE_AI_ASSESSMENT: "這是Premium功能，請升級您的訂閱以使用AI評估。",
  MARKING_SCHEME_MISSING: "缺少評分標準，請設置評分標準以使用AI評估。",
  SUBMISSION_SUMMARY: "{0}的提交總結",
  LOADING_SUMMARY: "正在載入總結...",
  LOADING_DATA: "正在載入資料...",
  PLEASE_PERFORM_AI_ASSESSMENT: "請至少進行一次AI評估以查看總結。",
  VIEW_SUMMARY: "查看AI評估總結",
  LOAD_ANSWERS_FAILED: "無法載入此提交的答案，請稍後再試。",
  MARKING_SCHEME_AND_AI_ASSESSMENT: "評分標準及AI評估",
  ASSESSMENT: "評估",
  CLICK_GET_AI_ASSESSMENT: "點擊以獲取AI評估",
  GET_AI_ASSESSMENT: "獲取AI評估",
  RE_RUN_AI_ASSESSMENT: "重新AI評估",
  NO_ADDITIONAL_GUIDELINES: "沒有提供額外指引。",
  BATCH_ASSESSMENT: "批量評估",
  AI_ASSESSABLE_QUESTIONS: "可AI評估問題",
  ONGOING_AI_ASSESSABLE_QUESTIONS: "剩餘問題",
  AI_ASSESSED_QUESTIONS: "已AI評估問題",
  COMPLETION_PERCENTAGE: "完成率",
  ASSESSMENT_COMPLETE: "評估完成",
  ASSESSMENT_SUMMARY: "評估總結",
  SCORE_DISTRIBUTION: "分數分佈",
  // Mirrors ex_flutterv1's Map > "View Route History" (map.settings.view_route_history),
  // and runs the same filter pipeline, so the two views agree.
  VIEW_ROUTE_HISTORY: "查看路線歷史",
  VIEW_ROUTE_HISTORY_TIP: "顯示此學生在實地考察期間的移動路線",
  NO_ROUTE_DATA: "此提交沒有移動記錄",
  // Submission card counters: "問題: 2/10" and "熱點: 2/5", and the hover tips
  // that break each one down by hotspot.
  HOTSPOT: "熱點",
  MORE: "項",
  QUESTION_PROGRESS_TIP: "已作答問題數目，佔本 LOCALE 全部問題",
  HOTSPOT_PROGRESS_TIP: "最少作答一題的熱點數目，佔本 LOCALE 全部熱點",
  // Assessment Summary chart view switcher.
  CHART_TAB_SCORE: "AI 評分",
  BAR_UNIT_STUDENTS: "每條長條：學生人數",
  BAR_UNIT_ANSWERS: "每條長條：答案數目",
  CHART_TAB_PAPER_SCORE: "試卷分",
  CHART_TAB_BY_TOPIC: "題目",
  PAPER_SCORE_MARKS: "分數",
  NO_PAPER_SCORE_DATA: "尚未有學生的答案獲得分數",
  SCORE_MARKS_TIP: "已得分數，佔本 LOCALE 問題所設定的總分",
  AI_PERCENT_TIP: "此學生 AI 評估百分比的平均值，是百分比而非分數",
  // Shown in place of the score bar when there is no score to draw.
  SCORE_NOT_SET: "未設定分數",
  SCORE_NOT_SET_TIP: "本 LOCALE 的問題未設定分數，因此沒有評分",
  SCORE_PENDING: "尚未評分",
  SCORE_PENDING_TIP: "本 LOCALE 已設定分數，但此學生的答案尚未有評分",
  NO_STUDENTS: "沒有學生",
  SCORE_PERCENT: "得分 (%)",
  AVERAGE_SCORE: "平均分",
  REFRESH_DATA: "刷新數據",
  PERFORMANCE_SUMMARY: "表現總結",
  BEST_PERFORMANCE_QUESTIONS: "表現最佳問題",
  ANSWERS: "答案",
  BEST_PERFORMANCE_STUDENTS: "表現最佳學生",
  WORST_PERFORMANCE_QUESTIONS: "最需要關注問題",
  WORST_PERFORMANCE_STUDENTS: "最需要關注學生",
  ASSESSMENT_STATISTICS: "評估統計",
  STUDENT_COUNT: "學生人數",
  QUESTIONS_PER_WORKSHEET: "每份工作紙問題數",
  ESTIMATED_TIME: "預計時間",
  MINUTES: "分鐘",
  START_NEW_AI_ASSESSMENT: "開始新的AI評估",
  START_NEW_AI_ASSESSMENT_WARNING: "開始新的評估將清除此工作紙之前所有的AI評估數據。您確定要繼續嗎？",
  RE_EXECUTE_AI_ASSESSMENT: "重新執行AI評估",
  RE_EXECUTE_AI_ASSESSMENT_WARNING: "重新執行評估將清除此工作紙之前所有的AI評估數據。您確定要繼續嗎？",
  CONFIRM_AI_ASSESSMENT: "確認AI評估",
  CONFIRM_SHARE_SUBMISSION: '確認分享提交',
  STUDENT_ANSWER: "學生答案",
  AI_SCORE: "AI評分",
  SHOW_ALL_ATTEMPTS: "顯示所有嘗試",
  NO_DATA: "沒有數據",
  COMPLETE_ASSESSMENT_FOR_DATA: "請完成AI評估以查看數據。",
  NO_PERFORMANCE_DATA: "沒有表現數據。",
  NOT_STARTED: "未開始",
  UPGRADE_TO_PREMIUM_FOR_AI: "請升級您的訂閱以使用AI評估",
  NO_ANSWER_ASSESSMENT: "沒有可評估的答案。",
  PREMIUM_FEATURE_EXPORT_ANSWERS: "請升級您的訂閱以使用匯出答案功能。",
  FIELD_TRIP_DATE: "實地考察日期",
  SUMMARY: "查看AI總結",
  VIEW_CLASS_SUMMARY: "查看全班的 AI 評估報告",
  INDIVIDUAL_STUDENT_SUBMISSIONS: "個別學生提交",
  ASSESSMENT_IN_PROGRESS: "評估進行中",
  RESUME_AI_ASSESSMENT: "繼續AI評估",
  RESUME_AI_ASSESSMENT_WARNING: "AI評估正在進行中。您想繼續嗎？",
  TIME_ESTIMATED: "預計時間：",
  DO_NOT_CLOSE: "評估進行中，請不要關閉此視窗。",
  ASSESSMENT_PROGRESS: "評估進度",
  TOTAL_ANSWERS: "總答案數",
  TOTAL_SUBMISSIONS: "總提交數量",
  COMPLETED_SUCCESSFULLY: "已完成",
  FAILED: "失敗",
  PENDING: "待處理",
  SAFE_TO_CLOSE: "評估完成，現在可以安全地關閉此視窗。",
  NO_QUESTIONS_FOR_AI_ASSESSMENT: "此提交中沒有可進行 AI 評估的問題。",
  AI_ASSESSMENT_STATISTICS: "AI評估統計",
  ASSESSMENT_STATISTICS: "評估統計",
  OVERALL_ASSESSMENT_STATISTICS: "評估統計概覽",
  VIEW_CLASS_OVERALL_SUMMARY: "查看全班的評估報告",
  SUBMISSION_BY: '提交者：',
  SUBMITTED_ON: '提交於：',
  VIEW_PUBLIC_LOCALE: "公共LOCALE",
  LOCALE_OF_MY_SCHOOL: "本校LOCALE",
  LOCALE_OF_MY_SCHOOL_1: "本校創建的LOCALE",
  LOCALE_ASSESSMENT: "需評估LOCALE",
  LOCALE_ASSESSMENT_1: "本校已使用的 LOCALE",
  LOCALE_ASSESSMENT_HELP: "本校學生曾提交答案的 LOCALE。",
  KLA: "學習領域",
  ORDER_BY: "排序",
  ORDER_MODE: "排序模式",
  ORDER_BY_TIME_CREATED: "建立時間",
  ORDER_BY_TIME_MODIFIED: "修改時間",
  ORDER_BY_EPACK_NAME: "名稱",
  ASCENDING: "升序",
  DESCENDING: "降序",
  HOTSPOT_VIEWER: "熱點編輯器",
  LOCALE_COLOR_REMINDER: "顏色設定使戶外考察在地圖上較容易被分辦，與考察內容無關",
  PUBLISHING_AND_SHARING_SETTINGS: "發布及分享設定",
  SHAREABLE_PUBLIC_MODE_DESC: "公開模式：其他學校的裝置也可看見本考察",
  SHAREABLE_SCHOOL_MODE_DESC: "本校模式：只有本校的裝置（已在App輸入School Key) 才可看見本考察",
  SHAREABLE_HINT: "設定為公開後，其他學校的裝置也可看見本考察；設定為本校後，只有已輸入School Key的本校裝置可看見",
  PUBLISH_MODE_DESC: "發佈模式：App能看見與搜尋本考察",
  UNPUBLISH_MODE_DESC: "不發佈：App不能看見本考察地圖",
  PUBLISH_HINT: "考察需設定為發布才會出現在App",
  // EDConnect related
  // Renamed per SSO spec 2026-08-19 — spec-literal, so the same string in BOTH
  // locales. Written with 教 (not the 敎 variant the rename first carried), to
  // match EDCITY_UNLINKED_TITLE — the brand must read one way across the app.
  // The dialog behind it still links EdCity, Google and Apple.
  EDCONNECT_BINDING: '教育城EdConnect',
  // --- Provider linking (Google/Apple) + composer SSO -----------------------
  GOOGLE_LOGIN_HINT: '教師：請先以密碼登入，再於帳戶綁定中連結 Google 帳戶。',
  GOOGLE_LOGIN_REFUSED: '此 Google 帳戶尚未連結教師帳戶。請先以密碼登入，再於帳戶綁定中連結。',
  LOGIN_WITH_APPLE: '以 Apple 帳戶登入',
  APPLE_LOGIN_REFUSED: '此 Apple 帳戶尚未連結教師帳戶。請先以密碼登入，再於帳戶綁定中連結。',
  LINKED_SIGNIN_METHODS: '已連結的登入方式',
  LINK_PASSWORD_LABEL: 'Composer 密碼',
  LINK_PASSWORD_HINT: '請先輸入 Composer 密碼確認，再選擇要連結的帳戶。連結後即可以該帳戶登入。',
  LINK_PASSWORD_REQUIRED: '密碼確認失敗，請檢查後再試。',
  // 與上一句分開：這裡並非密碼錯誤，而是根本未輸入。把「未輸入」說成
  // 「密碼錯誤」，會令教師誤以為要重設一個其實正常的密碼。
  LINK_PASSWORD_NEEDED: '請先在上方輸入 Composer 密碼以確認身分，然後再試一次。',
  LINK_GOOGLE_DONE: '已連結 Google 帳戶',
  LINK_GOOGLE_CONFLICT: '此 Google 帳戶已連結到其他使用者。',
  LINK_GOOGLE_FAILED: '無法連結 Google 帳戶，請再試一次。',
  LINK_WITH_APPLE: '連結 Apple 帳戶',
  LINK_APPLE_DONE: '已連結 Apple 帳戶',
  LINK_APPLE_CONFLICT: '此 Apple 帳戶已連結到其他使用者。',
  LINK_APPLE_FAILED: '無法連結 Apple 帳戶，請再試一次。',
  EDCONNECT_BIND_ALREADY_OTHER: '此 EdCity 帳戶已連結到其他使用者帳戶。',
  // 與上一句方向相反，切勿互換：上一句是「這個 EdCity 帳戶被別人佔用了」
  // （使用者自己無法處理），這一句是「你自己的帳戶已經連結了一個 EdCity
  // 帳戶」——而後者使用者在同一個對話框裡就能自行解決，所以句子必須說出
  // 解決方法，否則使用者只會看到一個沒有出路的錯誤。
  EDCONNECT_BIND_ACCOUNT_HAS_ONE: '此使用者帳戶已連結一個 EdCity 帳戶。每個使用者帳戶只可連結一個 EdCity 帳戶；如需改為連結另一個，請先移除現有的連結。',
  // 已連結時取代「新增帳戶」按鈕的說明文字。不是錯誤訊息，而是常態說明。
  EDCONNECT_ONE_ACCOUNT_ONLY: '每個使用者帳戶只可連結一個 EdCity 帳戶。如需改為連結另一個，請先移除上方的連結。',
  EDCONNECT_BIND_SCHOOL_MISMATCH: '此 EdCity 帳戶屬於另一所學校，無法與此使用者帳戶連結。',
  // 衝突的連結屬於一個由此 EdCity 身份「建立」出來的帳戶（自動開通）。
  // 不只說「已連結」：使用者需要知道該帳戶的資料無法轉移。
  EDCITY_CREATED_ACCOUNT_NO_MIGRATE: '此 EdCity 帳戶先前曾用於建立獨立帳戶，該帳戶的資料無法轉移至此使用者帳戶。',
  // --- 未連結 EdCity 的選擇對話框（?edconnect=2） ---------------------------
  // 對話框標題改用產品名稱，而非描述問題；兩個語言使用同一字串，
  // 與上方的 EDCONNECT_BINDING 完全相同（兩處統一使用「教」，不用「敎」異體字）。
  // 原本「尚未連結」的說明，現在改由內文第一句 EDCITY_CHOOSE_PROMPT 承擔。
  EDCITY_UNLINKED_TITLE: '教育城EdConnect',
  // 「選擇」畫面的開場句：該畫面現在只有兩個選項，沒有輸入欄位，
  // 因此必須先說明為何要使用者選擇。
  EDCITY_CHOOSE_PROMPT: '此 EdCity 帳戶尚未連結任何 EduVenture-AI 帳戶，請選擇如何繼續。',
  // 提示句（SSO spec 2026-08-19）：EdCity 學校已開通時顯示，兩個語言意思必須一致。
  // 現在顯示於第二個畫面（使用者選擇「連結原有EduVenture-AI帳號」之後）的輸入欄位上方。
  EDCITY_LINK_REMINDER: '如果你已有用戶名稱／電郵帳戶，可以先以該帳戶登入，然後將它與你的 EdCity 帳戶連結。',
  EDCITY_LOGIN_AND_LINK: '連結原有EduVenture-AI帳號',
  // 兩個選項按鈕下方的說明：輸入欄位移到第二個畫面之後，
  // 單靠按鈕文字已無法讓使用者分辨該選哪一個。
  EDCITY_LOGIN_AND_LINK_HINT: '如果你已有 EduVenture-AI 的用戶名稱／電郵帳戶，請選擇此項：登入一次後，該帳戶便會與你的 EdCity 帳戶連結。',
  EDCITY_CREATE_ACCOUNT: '建立新帳戶',
  EDCITY_CREATE_ACCOUNT_HINT: '如果你尚未擁有 EduVenture-AI 帳戶，請選擇此項：系統會建立新帳戶，並與你的 EdCity 帳戶連結。',
  // 開通前的確認訊息：只說出即將發生的事。標題已是「建立新帳戶」、
  // 按鈕已是「確定／取消」，因此不必再問「要繼續嗎？」，也不必重複
  // 上方 EDCITY_CREATE_ACCOUNT_HINT 已說過的前提；對話框會在這段文字
  // 後附上該 EdCity 身分。
  EDCITY_CREATE_CONFIRM: '系統將為此 EdCity 帳戶建立新的 EduVenture-AI 帳戶。',
  EDCITY_SCHOOL_UNKNOWN: '您的 EdCity 帳戶所屬學校尚未訂閱 EduVenture-AI，因此無法以此帳戶登入。請聯絡學校相關負責同工安排訂閱 EduVenture-AI，或者使用用戶名稱/電郵及密碼登入。',
  EDCITY_PENDING_EXPIRED: '此 EdCity 登入嘗試已逾時，請重新以 EdCity 登入。',
  // 「連結原有EduVenture-AI帳號」畫面上密碼錯誤時的提示。LoginPage.jsx:85 目前仍直接寫英文字串；
  // 此對話框不能這樣做－－首次以 EdCity 登入的使用者剛看完兩頁自己語言的畫面，
  // 而且最有可能打錯這個平時很少用到的密碼。
  LOGIN_INCORRECT: '用戶名稱／密碼不正確',
  // 登入被拒的說明，顯示在登入卡上，直至使用者關閉為止。
  SSO_REFUSED_TITLE: '無法登入',
  // 只寫給學生看的一句話。尚未連結的 EdCity 身分已經不會走到這裡－－它會拿到
  // 待決票據並開啟「連結原有帳號／建立帳戶」對話框（?edconnect=2）－－所以剩下會
  // 收到此 not_linked 拒絕的，實際上就是已連結但角色為學生（learner）的帳戶：
  // 例如先用 EduVenture-AI 應用程式以 EdCity 登入、之後再嘗試進入 Composer 的
  // 學生。對方要知道的只有「這是教師工具，請改用應用程式」，教師連結帳戶的指示
  // 對他們沒有用，只會把訊息變長。
  // 與 en.js 逐句對應：產品名稱（EduVenture-AI Composer／EduVenture-AI 應用程式）
  // 兩個語言必須一致，否則同一個拒絕在不同語言會指向兩個產品。
  SSO_REFUSED_NOT_LINKED: 'EduVenture-AI Composer是教師專用工具，請改用 EduVenture-AI 應用程式。',
  SSO_REFUSED_CANCELLED: '登入尚未完成便被取消。你可以再試一次，或在下方以用戶名稱及密碼登入。',
  SSO_REFUSED_UPSTREAM: '無法連接登入服務供應商。請稍後再試，或在下方以用戶名稱及密碼登入。',
  LINK_REMOVE: '移除登入方式',
  LINK_REMOVED: '已移除登入方式',
  LINK_INACTIVE: '已解除連結－再次以此方式登入會重新連結',
  // Subscription status labels
  SUPPORTED: '支援',
  NOT_SUPPORTED: '不支援',
  // 加上中文品牌名「教育城」：按鈕上只寫 EdConnect 的話，教師未必認得那就是
  // 香港教育城的登入。與對話框標題 EDCONNECT_BINDING（教育城EdConnect）一致。
  // 註：MUI Button 預設會把字轉成大寫，所以按鈕要另外設 textTransform: 'none'，
  // 否則畫面上會變成「EDCONNECT」而不是這裡寫的「EdConnect」。
  EDCONNECT_BIND_ACCOUNT: '綁定教育城 EdConnect 帳戶',
  // 空白狀態下按鈕上方的說明。原本這裡是一句英文（"Connect your EDConnect
  // account to enable single sign-on access."），而預設語言是繁體中文，所以
  // 大部分使用者看到的都是那句沒有翻譯的英文。
  EDCONNECT_BIND_HINT: '連結教育城 EdConnect 帳戶後，即可用它登入 EduVenture-AI。每個使用者帳戶只可連結一個 EdCity 帳戶。',
  // 登入在另一個視窗進行時顯示。必須說出「新視窗」－－視窗可能開在其他螢幕或
  // 被主視窗遮住，使用者看不見的話，跟「按了沒有反應」沒有分別。
  EDCONNECT_BIND_WAITING: '已在新視窗開啟教育城 EdConnect 登入。完成後這裡會自動更新。',
  EDCONNECT_LOADING_ACCOUNTS: '正在載入 EdConnect 帳戶…',
  EDCONNECT_UNBIND_ACCOUNT: '移除綁定',
  EDCONNECT_ACCOUNT_LINKED: 'EDConnect 帳戶已連結',
  EDCONNECT_ACCOUNT_NOT_LINKED: '沒有連結 EDConnect 帳戶',
  EDCONNECT_BIND_SUCCESS: 'EDConnect 帳戶綁定成功',
  EDCONNECT_UNBIND_SUCCESS: 'EDConnect 帳戶解除綁定成功',
  EDCONNECT_BIND_FAILED: 'EDConnect 帳戶綁定失敗',
  EDCONNECT_UNBIND_FAILED: 'EDConnect 帳戶解除綁定失敗',
  EDCONNECT_LINKED_ACCOUNT: '已連結帳戶：',
  EDCONNECT_ADD_ACCOUNT: '新增 EDConnect 帳戶',
  EDCONNECT_CONFIRM_REMOVE: '確定要移除此 EDConnect 帳戶綁定嗎？移除後可改為連結另一個 EdCity 帳戶。',
  LOGIN_WITH_EDCONNECT: '以 EdConnect 登入',
  CONTINUE_WITH_EDCONNECT: '以 EdConnect 繼續',
  EDCONNECT_SANDBOX_NOTE: 'Sandbox 帳戶',
  THIRD_PARTY_OR: '或',
  THIRD_APRTY_NO_LINKED: '未能找到與此第三方帳戶相關聯的使用者。請先完成帳戶綁定。',
  THIRD_APRTY_LOGIN_FAILED: '第三方登入失敗。請再試一次。',
  DATE_RANGE: "日期範圍",
  FROM: "從",
  TO: "到",
  
  // NPC Avatar Content Type
  NPC_AVATAR: "NPC 虛擬角色",
  NPC_AVATAR_DESCRIPTION: "具AI對話功能的互動虛擬角色",
  NPC_NAME: "角色名稱",
  NPC_AVATAR_SELECT: "角色頭像",
  NPC_VOICE_GENDER: "聲音性別",
  NPC_LANGUAGE: "語言",
  NPC_TIME_ALLOWED: "允許時間",
  NPC_PERSONALITY: "性格類型",
  NPC_BACKGROUND_INFO: "角色背景與知識",
  NPC_STUDENT_MISSION: "學生任務/評分標準",
  // NPC UI Section Headers
  NPC_BASIC_CONFIG: "基本設定",
  NPC_VOICE_LANGUAGE_CONFIG: "語音及語言設定",
  NPC_PERSONALITY_CONFIG: "性格設定",
  VOICE_MALE: "男性",
  VOICE_FEMALE: "女性",
  LANGUAGE_CHINESE: "香港(廣東話)",
  LANGUAGE_MANDARIN: "普通話",
  LANGUAGE_ENGLISH: "English",
  TIME_2_MIN: "2分鐘",
  TIME_5_MIN: "5分鐘",
  TIME_10_MIN: "10分鐘",
  PLEASE_SELECT: "請選擇",
  OPTIONAL: "選填",
  CHARACTERS: "字符",
  REQUIRED: "必填",
  
  // NPC Validation Messages
  NPC_NAME_NOT_FILLED: "角色名稱為必填",
  NPC_AVATAR_NOT_FILLED: "角色頭像為必選",
  NPC_VOICE_GENDER_NOT_FILLED: "聲音性別為必選",
  NPC_LANGUAGE_NOT_FILLED: "語言為必選",
  NPC_PERSONALITY_NOT_FILLED: "性格類型為必選",
  NPC_BACKGROUND_INFO_NOT_FILLED: "角色背景與知識為必填",
  NPC_STUDENT_MISSION_NOT_FILLED: "學生任務/評分標準為必填",
  // NPC per-locale quota
  NPC_QUOTA_LABEL: "此地點已使用的 NPC 配額",
  NPC_QUOTA_TOOLTIP: "此地點已建立 {0} 個 NPC，上限為 {1} 個。",
  NPC_LIMIT_REACHED_TITLE: "已達 NPC 數量上限",
  NPC_LIMIT_REACHED_MESSAGE: "此地點的 NPC 數量已達上限（{0}/{1}）。請先刪除現有的 NPC，才能建立新的 NPC。",
  COPIED_TO_CLIPBOARD: '已複製到剪貼簿',
  COPY: '複製',

  // Storage Info
  STORAGE_INFO: '儲存空間資訊',
  MY_STORAGE: '我的儲存空間',
  SCHOOL_STORAGE: '學校儲存空間',
  FILE_COUNT: '檔案',
  TOTAL_SIZE: '總大小',
  EPACK_NAME: '教件名稱',
  USER_NAME: '用戶',
  USER_LOGIN_NAME: '帳號',
  LOCALE_EPACK_COUNT: 'LOCALE 數量',
  SCHOOL_NAME: '學校',
  MAX_STORAGE: '儲存空間上限',
  STORAGE_USAGE: '儲存空間使用量',
  STORAGE_LIMIT_WARNING: '儲存空間已達上限，無法建立新的 LOCALE。請聯絡 apply@ev-cuhk.net 升級您的計劃。',
  NO_FILES: '沒有檔案',

  // Keys that were referenced with a `|| 'fallback'` but never defined, so they
  // had no translation at all (see the Localization proxy in Localization.jsx).
  ADD: '新增',
  USER: '用戶',
  ASSISTANT: '助手',
  CREATE_FAILED: '建立失敗',
  MAP_LOAD_FAILED: '地圖載入失敗',
  MAP_LOAD_FAILED_REMINDER: '請重新載入頁面或改用其他瀏覽器／裝置。如問題持續，請聯絡支援。',
  NO_DATE_SELECTED: '未選擇日期',
  REFRESHING: '正在重新整理...',
  RESUME_AI_ASSESSMENT_RESULT: '繼續評估完成：已處理 {1} 個答案中的 {0} 個（{2} 個失敗）',
  SESSION_EXPIRED: '登入狀態已過期，請重新登入。',
  EDCITY_LOGIN_SECTION: 'EdCity 登入',
  EDCITY_SCRN_TAB: 'EdCity 學校 ID 對接',
  EDCITY_SCRN_CODE: 'SCRN',
  EDCITY_SCRN_SCHOOL_NAME: 'EdCity 學校名稱',
  EDCITY_SCRN_OUR_SCHOOL_ID: '學校 ID',
  EDCITY_SCRN_OUR_SCHOOL_NAME: '學校名稱',
  EDCITY_SCRN_OUR_SCHOOL_NAME_ENG: '學校英文名稱',
  EDCITY_SCRN_CREATED: '建立日期',
  EDCITY_SCRN_NOT_MAPPED: '未對接',
  EDCITY_SCRN_CONNECT: '對接學校',
  EDCITY_SCRN_DISCONNECT: '清除對接',
  EDCITY_SCRN_REMOVE: '移除',
  EDCITY_SCRN_CREATE: '新增對接記錄',
  EDCITY_SCRN_FILTER_ALL: '所有記錄',
  EDCITY_SCRN_FILTER_MAPPED: '只顯示已對接',
  EDCITY_SCRN_FILTER_UNMAPPED: '只顯示未對接',
  EDCITY_SCRN_SEARCH_PLACEHOLDER: '搜尋 SCRN 或學校名稱...',
  EDCITY_SCRN_PICK_SCHOOL: '選擇本系統中的學校',
  EDCITY_SCRN_PICK_SCHOOL_OPTIONAL: '可留空，稍後再對接',
  EDCITY_SCRN_CODE_HINT: 'EDB 學校註冊編號 (SCRN)，須為 12 位數字',
  EDCITY_SCRN_CREATE_OK: '已新增對接記錄',
  EDCITY_SCRN_CREATE_FAILED: '新增對接記錄失敗',
  EDCITY_SCRN_CONNECT_OK: '已對接學校',
  EDCITY_SCRN_DISCONNECT_OK: '已清除對接',
  EDCITY_SCRN_UPDATE_FAILED: '更新對接記錄失敗',
  EDCITY_SCRN_REMOVE_OK: '已移除對接記錄',
  EDCITY_SCRN_REMOVE_FAILED: '移除對接記錄失敗',
  EDCITY_SCRN_REMOVE_CONFIRM: '確定要移除此 EdCity 對接記錄嗎？',
  EDCITY_SCRN_NO_RESULT: '沒有找到對接記錄',
  EDCITY_SCRN_VIEW_IN_SCHOOL_LIST: '在學校列表中檢視',
  EDCITY_SCRN_LOAD_FAILED: '載入對接列表失敗',
  // EdCity Login > 訂閱綁定 + 匯入對接 Excel
  SUBSCRIPTION_BINDING_TAB: '訂閱綁定',
  SUBSCRIPTION_BINDING_DESC: '設定「匯入對接 Excel」時，每種訂閱類型會複製哪個訂閱範本，以及新訂閱的名稱格式。可用變數：{school} 學校中文名稱、{school_en} 學校英文名稱、{plan} 類型 (體驗版/基本版/優越版)、{plan_en} 類型英文。',
  SUBSCRIPTION_BINDING_READONLY: '只有平台管理員可以更改訂閱綁定。',
  SUBSCRIPTION_BINDING_PLAN: '訂閱類型',
  SUBSCRIPTION_BINDING_TEMPLATE: '訂閱範本',
  SUBSCRIPTION_BINDING_PATTERN: '新訂閱名稱格式',
  SUBSCRIPTION_BINDING_PICK_TEMPLATE: '選擇訂閱範本',
  SUBSCRIPTION_BINDING_UNBOUND: '未綁定：匯入 CSV 時標記此類型的學校會被拒絕',
  SUBSCRIPTION_BINDING_MISSING: '訂閱已不存在',
  SUBSCRIPTION_BINDING_PREVIEW: '例：',
  SUBSCRIPTION_BINDING_SAMPLE_SCHOOL: 'XXX中學',
  SUBSCRIPTION_BINDING_SAMPLE_SCHOOL_EN: 'XXX Secondary School',
  SUBSCRIPTION_BINDING_PATTERN_HINT: '名稱格式必須包含 {school} 或 {school_en}',
  SUBSCRIPTION_BINDING_RELOAD: '重新載入',
  SUBSCRIPTION_BINDING_SAVED: '已儲存訂閱綁定',
  SUBSCRIPTION_BINDING_SAVE_FAILED: '儲存訂閱綁定失敗',
  SUBSCRIPTION_BINDING_LOAD_FAILED: '載入訂閱綁定失敗',
  SUBSCRIPTION_BINDING_DATES_TITLE: '學校訂閱期限',
  SUBSCRIPTION_BINDING_DATES_DESC: '匯入 CSV 時，為每間學校新增的訂閱都會使用這個開始日及到期日。未設定時，匯入只能對接 SCRN，不能建立訂閱。',
  SUBSCRIPTION_BINDING_DATES_UNSET: '未設定：匯入時無法建立訂閱',
  SUBSCRIPTION_BINDING_DATES_BOTH: '請同時填寫開始日及到期日，或兩者留空',
  SUBSCRIPTION_BINDING_DATES_ORDER: '到期日不可早於開始日',
  EDCITY_IMPORT_DATES: '學校訂閱期限：{0} 至 {1} (於「訂閱綁定」頁面設定)',
  EDCITY_IMPORT_DATES_UNSET: '尚未設定學校訂閱期限，請先於「訂閱綁定」頁面設定開始日及到期日',
  EDCITY_IMPORT_SCRN_EXCEL: 'SCRN 已被 Excel 轉成科學記號 (如 1E+11)，數字已遺失。請在 Excel 將 SCRN 欄設為「文字」格式，重新輸入 12 位數字後再儲存 CSV',
  EDCITY_IMPORT_HELP_EXCEL: '請使用下方的 Excel 範本：其 SCRN 欄已設為「文字」格式，12 位數字不會被 Excel 變成 1E+11。',
  EDCITY_IMPORT_BUTTON: '匯入對接 Excel',
  EDCITY_IMPORT_TITLE: '匯入對接 Excel',
  EDCITY_IMPORT_DOWNLOAD_TEMPLATE: '下載 Excel 範本',
  EDCITY_IMPORT_DOWNLOAD_TEMPLATE_TOOLTIP: '下載「匯入對接」的空白 Excel 範本 (SCRN 欄已設為文字格式)',
  EDCITY_IMPORT_UPLOAD: '上傳 Excel 檔案',
  EDCITY_IMPORT_HELP_1: '上傳 Excel 檔案 (.xlsx)，一次過對接多間學校的 EdCity SCRN，並按需要為每間學校建立及指派訂閱。第一行必須是欄位標題：',
  EDCITY_IMPORT_HELP_REQUIRED: '必要欄位 (每行均須填寫):',
  EDCITY_IMPORT_HELP_2: '每次最多 {0} 行。上傳後伺服器會先驗證每行資料，並以 AI 核對 EdCity 學校名稱與本系統學校是否相符；有疑問的學校會標示出來，由你決定是否匯入。確認後才會寫入資料庫。訂閱會按「訂閱綁定」頁面設定的範本建立。',
  EDCITY_IMPORT_VALIDATING: '正在驗證及以 AI 核對學校名稱，請稍候...',
  EDCITY_IMPORT_FAILED: 'Excel 匯入失敗',
  EDCITY_IMPORT_EXCEL_ONLY: '請上傳 Excel 檔案 (.xlsx)，可先下載 Excel 範本',
  EDCITY_IMPORT_NOTHING_SELECTED: '沒有選擇任何學校',
  EDCITY_IMPORT_AI_ERROR: 'AI 核對未能完成：{0}。未核對的學校已標示為需人手核對。',
  EDCITY_IMPORT_SELECT_CONFIRMED: '只選 AI 相符',
  EDCITY_IMPORT_SELECT_ALL_VALID: '選擇所有可匯入',
  EDCITY_IMPORT_CONFIRM: '確認匯入 {0} 間學校 (建立 {1} 個訂閱)',
  EDCITY_IMPORT_DONE_TOAST: '已匯入 {0} 間學校，建立 {1} 個訂閱',
  EDCITY_IMPORT_RESULT_TITLE: '已匯入 {0} 間學校',
  EDCITY_IMPORT_COL_PICK: '匯入',
  EDCITY_IMPORT_COL_PLANS: '訂閱',
  EDCITY_IMPORT_COL_AI: 'AI 核對',
  EDCITY_IMPORT_COL_STATUS: '狀態',
  EDCITY_IMPORT_MAP_CREATE: '新增對接',
  EDCITY_IMPORT_MAP_CONNECT: '對接現有 SCRN',
  EDCITY_IMPORT_MAP_KEEP: '對接已存在',
  EDCITY_IMPORT_ROW_DONE: '已匯入',
  EDCITY_IMPORT_REUSED: '(沿用已存在的訂閱)',
  EDCITY_IMPORT_AI_MATCH: '相符',
  EDCITY_IMPORT_AI_MISMATCH: '不相符',
  EDCITY_IMPORT_AI_UNCERTAIN: '不確定',
  EDCITY_IMPORT_AI_UNAVAILABLE: 'AI 無法核對',
  EDCITY_IMPORT_AI_SKIPPED: '未核對',

  // 學校活動記錄（學校管理員，role >= 2）— /api/activity/*，資料表
  // epack_activity_log：教師登入 + LOCALE 新增／更新／刪除／更改擁有者。
  // 欄位名稱為 ACTIVITY_FIELD_<COLUMN>。
  SCHOOL_ACTIVITY_MENU: '學校活動記錄',
  SCHOOL_ACTIVITY_TITLE: '學校活動記錄',
  ACTIVITY_TAB_TEACHERS: '教師',
  ACTIVITY_TAB_LOGINS: '登入記錄',
  ACTIVITY_TAB_LOCALES: 'LOCALE 操作記錄',
  ACTIVITY_COL_TIME: '時間',
  ACTIVITY_COL_TEACHER: '教師',
  ACTIVITY_COL_ACTION: '操作',
  ACTIVITY_COL_LOCALE: 'LOCALE',
  ACTIVITY_COL_DETAIL: '詳情',
  ACTIVITY_COL_METHOD: '登入方式',
  ACTIVITY_COL_SURFACE: '來源',
  ACTIVITY_COL_IP: 'IP 位址',
  ACTIVITY_COL_ROLE: '權限',
  ACTIVITY_COL_LAST_LOGIN: '最後登入',
  ACTIVITY_COL_LOGIN_COUNT: '登入次數',
  ACTIVITY_COL_ACTION_COUNT: 'LOCALE 操作次數',
  ACTIVITY_COL_LAST_ACTION: '最後 LOCALE 操作',
  ACTIVITY_FILTER_TEACHER: '教師',
  ACTIVITY_FILTER_ACTION: '操作',
  ACTIVITY_FILTER_ALL: '全部',
  ACTIVITY_FILTER_FROM: '由',
  ACTIVITY_FILTER_TO: '至',
  ACTIVITY_REFRESH: '重新整理',
  ACTIVITY_EMPTY: '沒有記錄',
  ACTIVITY_LOAD_FAILED: '無法載入活動記錄',
  ACTIVITY_TOTAL: '共 {0} 筆',
  ACTIVITY_VIEW_LOGINS: '登入記錄',
  ACTIVITY_VIEW_ACTIONS: '操作記錄',
  ACTIVITY_NEVER: '從未',
  ACTIVITY_ACTION_CREATE: '新增',
  ACTIVITY_ACTION_UPDATE: '更新',
  ACTIVITY_ACTION_DELETE: '刪除',
  ACTIVITY_ACTION_CHANGE_OWNER: '更改擁有者',
  ACTIVITY_ACTION_LOGIN: '登入',
  ACTIVITY_SURFACE_COMPOSER: '編輯器',
  ACTIVITY_SURFACE_APP: '應用程式',
  ACTIVITY_SURFACE_LEGACY: '舊版編輯器',
  ACTIVITY_METHOD_PASSWORD: '密碼',
  ACTIVITY_METHOD_GOOGLE: 'Google',
  ACTIVITY_METHOD_APPLE: 'Apple',
  ACTIVITY_METHOD_EDCITY: '教育城',
  ACTIVITY_DUPLICATED_FROM: '由 LOCALE #{0} 複製',
  ACTIVITY_DELETED_OWNER: '擁有者：#{0}',
  ACTIVITY_ROLE_0: '一般用戶',
  ACTIVITY_ROLE_1: '進階用戶',
  ACTIVITY_ROLE_2: '管理員',
  ACTIVITY_ROLE_3: 'CLST 管理員',
  ACTIVITY_FIELD_NAME: '名稱',
  ACTIVITY_FIELD_DESCRIPTION: '描述',
  ACTIVITY_FIELD_IS_SHARE: '分享',
  ACTIVITY_FIELD_IS_READY: '發佈',
  ACTIVITY_FIELD_IS_DUPLICATION_ALLOWED: '允許複製',
  ACTIVITY_FIELD_TN_FILE_ID: '封面圖片',
  ACTIVITY_FIELD_KLA: '學習領域',
  ACTIVITY_FIELD_SUBJECT: '科目',
  ACTIVITY_FIELD_LANG: '語言',
  ACTIVITY_FIELD_COLOR: '顏色',
  ACTIVITY_FIELD_HS_REVEAL_CODE: '揭示碼',
  ACTIVITY_FIELD_HS_REVEAL_CODE_ENABLED: '啟用揭示碼',
  ACTIVITY_FIELD_IS_AUTO_SHARE_ASSESSMENT: '自動分享評估',
  ACTIVITY_FIELD_IS_MANUAL_AI_ASSESSMENT: '手動 AI 評估',
  ACTIVITY_FIELD_IS_MOOD_ENABLED: '心情',
  ACTIVITY_FIELD_IS_NUDGE_ENABLED: '提示',
  ACTIVITY_FIELD_IS_CHAT_TEACHER_TO_STUDENT: '對話：教師對學生',
  ACTIVITY_FIELD_IS_CHAT_STUDENT_TO_STUDENT: '對話：學生對學生',
  ACTIVITY_FIELD_IS_CHAT_STUDENT_TO_TEACHER: '對話：學生對教師',
  ACTIVITY_FIELD_MAP_AREA: '地圖範圍',
  // 更改擁有者（學校管理員，本校）
  CHANGE_OWNER: '更改擁有者',
  CHANGE_OWNER_TITLE: '更改 LOCALE 擁有者',
  CHANGE_OWNER_CURRENT: '現時擁有者',
  CHANGE_OWNER_NEW: '新擁有者',
  CHANGE_OWNER_HINT: '只可選擇本校的教師帳戶；LOCALE 仍屬於本校。',
  CHANGE_OWNER_CONFIRM: '更改',
  CHANGE_OWNER_DONE: '已更改擁有者',
  CHANGE_OWNER_FAILED: '無法更改擁有者',
  CHANGE_OWNER_INVALID: '新擁有者必須是本校的教師帳戶',
  CHANGE_OWNER_NO_USERS: '本校沒有其他教師帳戶',

  // 管理任務 — 用戶管理（學校管理員 role 2 所見；平台管理員另有其餘頁面）。
  // 建立用戶／用戶列表及編輯、更改密碼、刪除對話框的所有文字。
  ADMIN_ROLE_LABEL: '權限',
  ADMIN_ROLE_0: '一般用戶',
  ADMIN_ROLE_1: '進階用戶',
  ADMIN_ROLE_2: '管理員',
  ADMIN_ROLE_UNKNOWN: '未知',
  ADMIN_SCHOOL_ID: '學校編號',
  ADMIN_SCHOOL_INFO: '學校資訊',
  ADMIN_IMPORT_LATEST_SCHOOL: '導入最近建立學校ID',
  ADMIN_IMPORTED_SCHOOL_ID: '已導入最新學校 ID: {0}',
  ADMIN_NO_SCHOOL_FOUND: '沒有找到學校資料',
  ADMIN_IMPORT_SCHOOL_FAILED: '獲取最新學校失敗',
  ADMIN_BATCH_CREATE_USERS: '批量建立用戶 (CSV)',
  ADMIN_ERR_USERNAME_REQUIRED: '請輸入用戶名稱',
  ADMIN_ERR_PASSWORD_REQUIRED: '請輸入密碼',
  ADMIN_ERR_PASSWORD_TOO_SHORT: '密碼長度至少需要6個字符',
  ADMIN_ERR_SCHOOL_ID_REQUIRED: '請輸入學校編號',
  ADMIN_CREATE_USER_FAILED: '建立用戶失敗',
  ADMIN_CHECK_INPUT: '請檢查輸入資料是否正確',
  ADMIN_CHECK_NETWORK: '請檢查網路連線或聯絡系統管理員',
  ADMIN_USER_SEARCH_PLACEHOLDER: '可搜尋用戶名稱、顯示名稱、電郵',
  ADMIN_USER_SEARCH_HINT: '請輸入搜尋條件並點擊搜尋按鈕(可搜尋用戶名稱、顯示名稱、電郵)',
  ADMIN_USER_LIST_EMPTY: '本校沒有用戶',
  ADMIN_REFRESH_RESULTS: '重新整理搜尋結果',
  ADMIN_COL_ID: '編號',
  ADMIN_COL_LAST_LOGIN: '最近登入',
  ADMIN_EDIT_USER: '編輯用戶',
  ADMIN_DELETE_USER: '刪除用戶',
  ADMIN_ERR_SEARCH_REQUIRED: '請輸入搜尋條件',
  ADMIN_SEARCH_FOUND: '找到 {0} 名用戶',
  ADMIN_SEARCH_EMPTY: '搜尋結果為空',
  ADMIN_SEARCH_FAILED: '搜尋失敗',
  ADMIN_NEVER_LOGGED_IN: '從未登入',
  ADMIN_INVALID_DATE: '無效日期',
  ADMIN_DATE_FORMAT_ERROR: '格式錯誤',
  ADMIN_PW_DIALOG_TITLE: '更改用戶密碼',
  ADMIN_TARGET_USER: '目標用戶',
  ADMIN_PASSWORD: '管理員密碼',
  ADMIN_PASSWORD_DESC: '輸入您的管理員密碼以確認身份',
  ADMIN_NEW_USER_PASSWORD: '目標用戶新密碼',
  ADMIN_PASSWORD_MIN_DESC: '密碼長度至少6個字符',
  ADMIN_CONFIRM_NEW_PASSWORD: '目標用戶新密碼(再輸入一次)',
  ADMIN_CONFIRM_NEW_PASSWORD_DESC: '請再次輸入新密碼',
  ADMIN_ERR_PASSWORDS_DIFFER: '密碼不相符',
  ADMIN_ERR_FILL_ALL: '請填寫所有欄位',
  ADMIN_ERR_PASSWORD_MISMATCH: '新密碼與確認密碼不相符',
  ADMIN_ERR_NO_ADMIN_ID: '無法獲取管理員身份，請重新登入',
  ADMIN_PW_CHANGED: '用戶 {0} 的密碼已成功更改',
  ADMIN_PW_CHANGE_FAILED: '密碼更改失敗',
  ADMIN_ERR_ADMIN_PASSWORD_REQUIRED: '請輸入管理員密碼',
  ADMIN_WARNING: '警告',
  ADMIN_DELETE_WARNING: '此操作會將用戶帳號名稱更改為 "Deleted-{0}"，該用戶將無法再登入。',
  ADMIN_CONFIRM_DELETE: '確認刪除',
  ADMIN_USER_DELETED: '用戶 {0} 已成功刪除',
  ADMIN_DELETE_FAILED: '刪除用戶失敗',
  ADMIN_USER_UPDATED: '用戶 {0} 的資料已成功更新',
  ADMIN_UPDATE_FAILED: '更新用戶資料失敗',
  ADMIN_SAVE_CHANGES: '儲存變更',
};
